import { Fragment, ReactElement, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBagShopping /*, faGear*/, faAngleRight, faFileLines as faFileLinesSolid } from '@fortawesome/free-solid-svg-icons'
import { faBookmark } from '@fortawesome/pro-regular-svg-icons'
import { faUpToLine, faCloud, faCloudSlash, faSheetPlastic, faHandHoldingBox, faFilePen, faShelves, faGem, faCloudXmark, faTrashXmark, faSignature, faBox, faScaleBalanced, faObjectGroup, faFlagCheckered, faUserMagnifyingGlass, faRecycle } from '@fortawesome/pro-solid-svg-icons'
import {
   faBadgeCheck,
   faFilePdf,
   faClone,
   faCloudArrowUp,
   faPenToSquare,
   faEye,
   faTrashCan,
   faArrowRight,
   faLock,
   faLockOpen,
   faFileImport,
   faCircleXmark,
   faRotateLeft,
   faSheetPlastic as faSheetPlasticLight,
   faGem as faGemLight,
   faBox as faBoxLight,
   faScaleBalanced as faScaleBalancedLight,
   faObjectGroup as faObjectGroupLight,
   faCoins
} from '@fortawesome/pro-light-svg-icons'
import styles_Searchbar from '../components/Searchbar.module.scss'
import DropdownMenu from '../components/DropdownMenu'
import ReliquatConfirm from '../components/RetailValidation/ReliquatConfirm'
import Menu from '../components/Menu/Menu'
import Searchbar from '../components/Searchbar'
import usePrefStore from '../stores/prefs'
import styles from './Orders.module.scss'
import useHelpers from '../Hooks/useHelpers'
import { Checkbox, States as CheckboxStates } from '../components/Checkbox'
import PagesButtons from '../components/PagesButtons'
import useTranslation from '../Hooks/useTranslation'
import { useNavigate } from 'react-router-dom'
import DropdownField from '../components/DropdownField'
import Button from '../components/Button'
import useSales from '../Hooks/useSales'
import { useCatalogScopeFlags } from '../Hooks/useIsRetailOnly'
import useCanSeeJewelry from '../Hooks/useCanSeeJewelry'
// import { useLogger } from '../Contexts/Logger'
// import { useState } from "react"
import { useLiveQuery } from 'dexie-react-hooks'
import { AppWriteContext } from '../Contexts/AppWriteContext'
import Confirm from '../components/Confirm'
import { ToastContainer, toast } from 'react-toastify'
import MailAddressPicker from '../components/MailAddressPicker'
import { GlobalContext } from '../Contexts/GlobalContext'
import moment from 'moment'
import glob_const from '../libs/glob_const'
import { TRI_TYPE, splitLinesToUnit } from '../libs/triOrder'
import useRetailQuota, { mergeKTMIntoKOTLines } from '../Hooks/useRetailQuota'
import type { KTMDeployOptions } from '../Hooks/useRetailQuota'
import useRetailCollections from '../Hooks/useRetailCollections'
import useFinalValidation from '../Hooks/useFinalValidation'
import useReturnToClient from '../Hooks/useReturnToClient'
import useSubmitOrder from '../Hooks/useSubmitOrder'
import useRetailRoleForCustomer, { computeRetailRoleForCustomer } from '../Hooks/useRetailRoleForCustomer'
import type { Order, Customer, KTMClientType } from '../types'
import { importKOTFile, validateKOTLines } from '../libs/kotExportImport'
import QuotaMarkEditor from '../components/QuotaMarkEditor'
import KTMDeployer from '../components/KTMDeployer'
import ProgressPopup from '../components/ProgressPopup'

const tabs = {
   sync: 'sync',
   unsync: 'unsync',
   pending: 'pending',
   submitted: 'submitted',
   quotas: 'quotas',
   templates: 'templates',
   kotdebug: 'kotdebug' // onglet DEBUG : tous les KOT, lecture seule (visible si mode debug)
}

const global_menu_items = {
   doSync: 'sync',
   doSubmit: 'submit'
}

const menu_items = {
   doEdit: 'edit',
   setActive: 'active',
   sendPdf: 'sendpdf',
   doDelete: 'delete',
   doClone: 'duplicate',
   doCloneToDefaultCustomer: 'duplicate_to_defcust',
   doDeployKTM: 'deploy_ktm',
   doUnDeployKTM: 'undeploy_ktm',
   doSync: 'sync',
   doSee: 'see',
   doValidateN2: 'validate_n2',
   doValidateN1: 'validate_n1',
   doUnlock: 'unlock',
   doSendToClient: 'send_to_client'
}

const search_type = {
   in_orders: 'in_orders',
   sku: 'sku'
}

const create_menu_items = {
   template: 'create_template',
   order: 'create_order',
   retail: 'create_retail',
   kot: 'create_kot',
   editKot: 'edit_kot',
   importKot: 'import_kot',
   ktmRet: 'create_ktm_ret',
   ktmEre: 'create_ktm_ere',
   ktmInterco: 'create_ktm_interco',
   importJSON: 'import_json'
}

function Orders() {
   const listPageLength = Number(usePrefStore((state) => state.listPageLength))
   // const setListPageLength = usePrefStore((state) => state.setListPageLength)
   // const curOrder = usePrefStore((state) => state.curOrder);
   const { setListPageLength, curOrder, curCustomer, setCurOrder, curTarifRegionName, curTarifRegion, setCurCustomer, retailRole, isRetailManager, supervisedN1, supervisedN2, debug } = usePrefStore()
   const { setIsDarkLayerVisible } = { ...GlobalContext() } as any
   //
   // const [isSearchFilterVisible, setIsSearchFilterVisible] = useState(false)
   const [searchText, setSearchText] = useState('')
   const [searchBar, setSearchBar] = useState<ReactElement | null>(null)
   const [countFailedSyncOrders, setCountFailedSyncOrders] = useState(0)
   const [allSyncOrders, setAllSyncOrders] = useState<Order[] | null>(null) // Toutes les commandes, triées
   const [allUnsyncOrders, setAllUnsyncOrders] = useState<Order[] | null>(null) // Toutes les commandes, triées
   const [filteredUnsyncOrders, setFilteredUnsyncOrders] = useState<Order[] | null>(null)
   const [filteredSyncOrders, setFilteredSyncOrders] = useState<Order[] | null>(null)
   const [filteredTemplateOrders, setFilteredTemplateOrders] = useState<Order[] | null>(null)
   const [filteredPendingOrders, setFilteredPendingOrders] = useState<Order[] | null>(null)
   const [filteredSubmittedOrders, setFilteredSubmittedOrders] = useState<Order[] | null>(null)
   const [filteredQuotaOrders, setFilteredQuotaOrders] = useState<Order[] | null>(null)
   const [curPageUnsyncOrders, setCurPageUnsyncOrders] = useState<Order[] | null>(null) // Commandes (unsync) affichées sur la page courante
   const [curPageSyncOrders, setCurPageSyncOrders] = useState<Order[] | null>(null) // Commandes (sync) affichées sur la page courante
   const [curPageTemplateOrders, setCurPageTemplateOrders] = useState<Order[] | null>(null)
   const [curPagePendingOrders, setCurPagePendingOrders] = useState<Order[] | null>(null)
   const [curPageSubmittedOrders, setCurPageSubmittedOrders] = useState<Order[] | null>(null)
   const [curPageQuotaOrders, setCurPageQuotaOrders] = useState<Order[] | null>(null)
   const [pagesButtonsSync, setPagesButtonsSync] = useState<ReactElement | null>(null)
   const [pagesButtonsUnsync, setPagesButtonsUnsync] = useState<ReactElement | null>(null)
   const [pagesButtonsTemplates, setPagesButtonsTemplates] = useState<ReactElement | null>(null)
   const [pagesButtonsPending, setPagesButtonsPending] = useState<ReactElement | null>(null)
   const [pagesButtonsSubmitted, setPagesButtonsSubmitted] = useState<ReactElement | null>(null)
   const [pagesButtonsQuotas, setPagesButtonsQuotas] = useState<ReactElement | null>(null)
   const [unsyncLines, setUnsyncLines] = useState<ReactElement[] | null>(null)
   const [syncLines, setSyncLines] = useState<ReactElement[] | null>(null)
   const [templateLines, setTemplateLines] = useState<ReactElement[] | null>(null)
   const [pendingLines, setPendingLines] = useState<ReactElement[] | null>(null)
   const [submittedLines, setSubmittedLines] = useState<ReactElement[] | null>(null)
   const [quotaLines, setQuotaLines] = useState<ReactElement[] | null>(null)
   const [kotDebugLines, setKotDebugLines] = useState<ReactElement[] | null>(null)
   const [unsyncLinesChecked, setUnsyncLinesChecked] = useState<Set<string>>(new Set())
   // const [syncLinesChecked, setSyncLinesChecked] = useState(new Set())
   const [unsyncLinesAllChecked, setUnsyncLinesAllChecked] = useState(false)
   // const [syncLinesAllChecked, setSyncLinesAllChecked] = useState(false)
   const [unsyncLinesNoneChecked, setUnsyncLinesNoneChecked] = useState(false)
   // const [syncLinesNoneChecked, setSyncLinesNoneChecked] = useState(false)
   const [searchParams] = useSearchParams()
   const [curOrderType, setCurOrderType] = useState(() => {
      const tab = searchParams.get('tab')
      return tab && Object.values(tabs).includes(tab) ? tab : tabs.unsync
   })
   const [curPageSync, setCurPageSync] = useState(1)
   const [nbPagesSync, setNbPagesSync] = useState(1)
   const [firstPageSync, setFirstPageSync] = useState(1)
   const [curPageUnsync, setCurPageUnsync] = useState(1)
   const [nbPagesUnsync, setNbPagesUnsync] = useState(1)
   const [firstPageUnsync, setFirstPageUnsync] = useState(1)
   const [curPageTemplates, setCurPageTemplates] = useState(1)
   const [nbPagesTemplates, setNbPagesTemplates] = useState(1)
   const [firstPageTemplates, setFirstPageTemplates] = useState(1)
   const [curPagePending, setCurPagePending] = useState(1)
   const [nbPagesPending, setNbPagesPending] = useState(1)
   const [firstPagePending, setFirstPagePending] = useState(1)
   const [curPageSubmitted, setCurPageSubmitted] = useState(1)
   const [nbPagesSubmitted, setNbPagesSubmitted] = useState(1)
   const [firstPageSubmitted, setFirstPageSubmitted] = useState(1)
   const [curPageQuotas, setCurPageQuotas] = useState(1)
   const [nbPagesQuotas, setNbPagesQuotas] = useState(1)
   const [firstPageQuotas, setFirstPageQuotas] = useState(1)
   const [dropdownMenu, setDropdownMenu] = useState<ReactElement | null>(null)
   const [showDropdownMenuOnOrderId, setShowDropdownMenuOnOrderId] = useState<string | null>(null)
   const [deleteOrderId, setDeleteOrderId] = useState<string | null>(null)
   const [isItemsPerPageOpen, setIsItemsPerPageOpen] = useState(false)
   const [selectedOrder, setSelectedOrder] = useState<Order | null>(null)
   // Rôle vis-à-vis du customer de la commande sélectionnée dans le menu déroulant.
   // Le menu déroulant agit sur un order précis : la visibilité des entrées
   // (Valider N1/N2, Renvoyer au client, etc.) dépend du rôle N1/N2 pour CE customer.
   const roleForSelected = useRetailRoleForCustomer(selectedOrder?.customer_id)
   // Rôle vis-à-vis du curCustomer (pour le bouton "Créer commande Retail")
   const roleForCurCustomer = useRetailRoleForCustomer(curCustomer)
   // Helper pour les boucles de filtres (les hooks ne peuvent pas être appelés
   // dans une boucle). Utilise les valeurs déjà lues du store.
   const roleForOrder = useCallback((cust_id: string | null | undefined) => computeRetailRoleForCustomer(cust_id, retailRole, isRetailManager, supervisedN1, supervisedN2), [retailRole, isRetailManager, supervisedN1, supervisedN2])
   // Indique si le user est un manager (admin OU manager déclaré dans prefs) — sert pour
   // la visibilité des onglets "À valider", "Soumises" au niveau page.
   const isManagerOrAdmin = retailRole === 'admin' || isRetailManager
   // KOT : seuls admin et N1 (d'au moins un customer) gèrent les documents quota. Le N2 en est
   // exclu (traité comme user-client : quota en local pour le picker, mais pas d'accès document).
   const canManageKOT = retailRole === 'admin' || (supervisedN1?.length ?? 0) > 0
   const [isConfirmDeleteVisible, setIsConfirmDeleteVisible] = useState(false)
   const [isConfirmSyncVisible, setIsConfirmSyncVisible] = useState(false)
   const [isConfirmSubmitVisible, setIsConfirmSubmitVisible] = useState(false)
   const [isMailAddressPickerVisible, setIsMailAddressPickerVisible] = useState(false)
   const [showValidateConfirm, setShowValidateConfirm] = useState(false)
   const [validateMode, setValidateMode] = useState<'n1' | 'n2' | null>(null)
   const [validateOrderId, setValidateOrderId] = useState<string | null>(null)
   const [validateOrder, setValidateOrder] = useState<Order | null>(null)
   const [refusedLinesForPopup, setRefusedLinesForPopup] = useState<{ sku: string; label: string; origQty: number; curQty: number; reliquat: number }[]>([])
   const [checkedRefusedLines, setCheckedRefusedLines] = useState<boolean[]>([])
   const [searchMode, setSearchMode] = useState(search_type.in_orders)
   const [filterCDE, setFilterCDE] = useState(false)
   const [filterCDI, setFilterCDI] = useState(false)
   const [filterCON, setFilterCON] = useState(false)
   const [filterTRI, setFilterTRI] = useState(false)
   const [filterOME, setFilterOME] = useState(false)
   const [filterDEV, setFilterDEV] = useState(false)
   const [filterRET, setFilterRET] = useState(false) // filtre ECR+ECF (mode mixte retail+bijoux)
   const [lastPickedOrderId, setLastPickedOrderId] = useState<string | null>(null) // Pour envoi PDF
   const [lastPickedOrderCustId, setLastPickedOrderCustId] = useState<string | null>(null) // Pour envoi PDF
   //
   const { formatCESPrice } = useHelpers()
   const { trans, lowtrans, transWithParams } = useTranslation()
   const navigate = useNavigate()
   const {
      order_status,
      setOrderIdAsCurrent,
      getOrderById,
      getCustomerById,
      getCustomersAsSortedArray,
      getUnsyncOrdersAsArray,
      getSyncOrdersAsArray,
      calcTotalForOrder,
      updateRecentOrders,
      updateOrder,
      type_order,
      cloneOrder,
      deleteOrder,
      canSyncOrder,
      isOrderComplete,
      canWriteKOT,
      createOrder,
      makeTemplateOrder,
      isRetailOrder,
      countCheckedRetail,
      orderMatchesSearch,
      isKOTOrder,
      isKTMOrder,
      canCreateRetailOrder,
      canCreateBijouxOrder,
      getRetailOrderType,
      computeRefusedLines,
      submitRetailOrder,
      validateRetailN2,
      validateRetailN1,
      returnRetailToClient,
      sendRetailToClient,
      isOrderSubmittedOrLocked,
      hasN1Validator
   } = useSales()
   // Pictos de synchro — cas particulier du USER-CLIENT retail : on ne lui expose pas le détail
   // du workflow interne de validation (il n'a pas à savoir si sa commande est chez le N1 ou le N2).
   //   - wait_n1 / wait_n2  → loupe-user À LA PLACE du nuage, rien en dessous ("en cours d'examen")
   //   - locked / wait_m3   → nuage seul, sans le "M3" en dessous
   // Les autres rôles (admin / N1 / N2 / commercial) gardent l'affichage complet N1/N2/M3.
   // NB : défini APRÈS useSales() — isRetailOrder et order_status en sont issus.
   const hideRetailWorkflow = useCallback((an_order: Order) => retailRole === 'client' && isRetailOrder(an_order), [retailRole, isRetailOrder])
   const isUnderRetailReview = useCallback((an_order: Order) => hideRetailWorkflow(an_order) && (an_order.status === order_status.wait_n1 || an_order.status === order_status.wait_n2), [hideRetailWorkflow, order_status])
   const { canCreateKOT, canCreateKTM, generateKOTMark, generateKTMMark, extractClientTypeFromKTMMark, extractPeriodFromKTMMark, findKOTByPeriod, findCurrentKOT, KTM_CLIENT_TYPES } = useRetailQuota()
   const { getRetailModelById } = useRetailCollections()
   const { isRetailOnly, hasBoth } = useCatalogScopeFlags()
   const canSeeJewelry = useCanSeeJewelry() // false = retail-only : masque Modèles / Modèle Quotas
   const { requestFinalValidation, finalValidationPopups } = useFinalValidation({ validateRetailN1, computeRefusedLines, isRetailOrder, getRetailModelById })
   const { requestReturnToClient, returnToClientPopups } = useReturnToClient({ sendRetailToClient, returnRetailToClient, newMgrStatus: order_status.new_mgr })
   const { requestSubmit, submitPopups } = useSubmitOrder({ submitRetailOrder, updateOrder, isRetailOrder, lockedForSyncStatus: order_status.locked4sync })
   // const { log, error } = useLogger()
   //
   const live_unsync_orders = useLiveQuery(getUnsyncOrdersAsArray)
   const live_sync_orders = useLiveQuery(getSyncOrdersAsArray)
   // const test_orders = useLiveQuery(() => db.orders_synced.toArray())
   const { awPushWaitingOrders, awPushPDF, addFakeLocalCustomer } = { ...AppWriteContext() } as any
   const [showDropdownMenuGlobal, setShowDropdownMenuGlobal] = useState(false)
   const [dropdownMenuGlobal, setDropdownMenuGlobal] = useState<ReactElement | null>(null)
   const [showCreateMenu, setShowCreateMenu] = useState(false)
   const [showQuotaMarkEditor, setShowQuotaMarkEditor] = useState(false)
   const [showKtmDeployer, setShowKtmDeployer] = useState(false)
   const [ktmToDeploy, setKtmToDeploy] = useState<Order | null>(null)
   const [unDeployKtm, setUnDeployKtm] = useState<Order | null>(null)
   const [unDeployAffected, setUnDeployAffected] = useState<Customer[]>([])
   const [unDeployCheckedIds, setUnDeployCheckedIds] = useState<string[]>([])
   const [deployProgress, setDeployProgress] = useState<{ label: string; done: number; total: number } | null>(null)
   const [quotaInitialMark, setQuotaInitialMark] = useState<string | null>(null)
   const [quotaIsKOT, setQuotaIsKOT] = useState(false)
   const [quotaCloneSourceId, setQuotaCloneSourceId] = useState<string | null>(null)
   const [quotaCloneTargetCustomerId, setQuotaCloneTargetCustomerId] = useState<string | null>(null)
   // Mode "création KOT via picker" (quand un KOT existe déjà pour le mois courant) : customer cible
   const [quotaCreateKOTCustomerId, setQuotaCreateKOTCustomerId] = useState<string | null>(null)
   // KOT actif du client sélectionné (précalculé pour afficher l'entrée "Modifier quotas")
   const [currentKOTForCurCustomer, setCurrentKOTForCurCustomer] = useState<Order | null>(null)
   const [default_customer, setDefaultCustomer] = useState<Customer | undefined>()
   const kotImportFileRef = useRef<HTMLInputElement>(null)
   const jsonImportFileRef = useRef<HTMLInputElement>(null)

   // console.log(null.map(a => a)) // Force plantage pour tester ErrorBoundary

   useEffect(() => {
      if (curCustomer) {
         setDefaultCustomer(getCustomerById(curCustomer))
      } else {
         setDefaultCustomer(null)
      }
   }, [curCustomer, getCustomerById])

   // Garantit que les fake customers KTM_* référencés par des commandes existent
   // (et qu'ils ont le libellé à jour). Idempotent : addFakeLocalCustomer fait un put.
   useEffect(() => {
      if (!live_unsync_orders) return
      const neededTypes = new Set<KTMClientType>()
      for (const o of live_unsync_orders) {
         if (o.customer_id?.startsWith(glob_const.prefix_ktm)) {
            const t = o.customer_id.substring(glob_const.prefix_ktm.length) as KTMClientType
            if (t === 'RET' || t === 'ERE' || t === 'INT') neededTypes.add(t)
         }
      }
      if (neededTypes.size === 0) return
      ;(async () => {
         for (const t of neededTypes) {
            const id = `${glob_const.prefix_ktm}${t}`
            await addFakeLocalCustomer({
               number: id,
               id,
               name: `<QUOTAS ${KTM_CLIENT_TYPES[t]}>`,
               phones: [],
               email: [],
               tariffs: JSON.stringify({ ces: { tarif: null, currency: null }, ppu: { tarif: null, currency: null } }),
               depot: null,
               credit: null,
               factures_ouvertes: null,
               contacts: [],
               addresses: [],
               last_updated: moment().toISOString()
            })
         }
      })()
   }, [live_unsync_orders, addFakeLocalCustomer, KTM_CLIENT_TYPES])

   const sortOrders = (a, b) => {
      let comp = 0
      if (typeof a.date === 'string' && typeof b.date === 'string') {
         comp = b.date.localeCompare(a.date)
      }
      if (comp === 0) {
         comp = b.id.localeCompare(a.id)
      }
      return comp
   }

   useEffect(() => {
      setAllSyncOrders(
         live_sync_orders
            ?.filter((an_order) => {
               if (an_order.type === type_order.confie_facture) return false
               // Filtre per-customer : le user ne voit les DOCUMENTS KOT/KTM que s'il est
               // admin ou N1 pour le customer de la commande. Le N2 (comme le user-client)
               // a bien le KOT en local pour le quota du picker, mais PAS accès au document.
               const r = roleForOrder(an_order.customer_id)
               if (!(r.isAdmin || r.isN1) && (an_order.type === type_order.retail_quota || an_order.type === type_order.ktm_quota)) return false
               return true
            })
            .sort(sortOrders)
      )
   }, [live_sync_orders, roleForOrder, type_order])

   useEffect(() => {
      setAllUnsyncOrders(
         live_unsync_orders
            ?.filter((an_order) => {
               if (an_order.type === type_order.ktm_quota) return false
               if (an_order.type === type_order.retail_quota) return false
               if (an_order.status === order_status.wait_n1 || an_order.status === order_status.wait_n2) return false
               // Retail : locked / wait_m3 sont en suivi LECTURE SEULE dans l'onglet "Soumises".
               // On les exclut de "En cours" (sinon double affichage). Scopé au retail : les
               // commandes oMe classiques passent légitimement par 'locked' avant sync M3.
               if (isRetailOrder(an_order) && (an_order.status === order_status.locked || an_order.status === order_status.wait_m3)) return false
               if (an_order.customer_id.startsWith(glob_const.prefix_prospect)) return false
               if (an_order.customer_id.startsWith(glob_const.prefix_ktm)) return false
               return true
            })
            .sort(sortOrders)
      )
      // Onglet "Quotas" : KOT/KTM non sync, réservés admin/N1 du customer. Le N2 n'accède
      // pas aux documents KOT (traité comme un user-client), seul le picker utilise son quota.
      setFilteredQuotaOrders(
         live_unsync_orders
            ?.filter((an_order) => {
               if (!orderMatchesSearch(an_order, searchText, searchMode === search_type.sku)) return false
               const r = roleForOrder(an_order.customer_id)
               if (!(r.isAdmin || r.isN1)) return false
               return an_order.type === type_order.retail_quota || an_order.type === type_order.ktm_quota
            })
            .sort(sortOrders)
      )
      // Onglet "À valider" : commandes en attente de MON action sur ce customer précis.
      // N2 (de ce customer) : wait_n2 uniquement
      // N1 (de ce customer) : wait_n1 uniquement
      // Admin : wait_n1 + wait_n2
      setFilteredPendingOrders(
         live_unsync_orders
            ?.filter((an_order) => {
               if (!orderMatchesSearch(an_order, searchText, searchMode === search_type.sku)) return false
               const r = roleForOrder(an_order.customer_id)
               if (r.isAdmin) return an_order.status === order_status.wait_n1 || an_order.status === order_status.wait_n2
               if (r.isN1) return an_order.status === order_status.wait_n1
               if (r.isN2) return an_order.status === order_status.wait_n2
               return false
            })
            .sort(sortOrders)
      )
      // Onglet "Soumises" : suivi en LECTURE SEULE (modèle cumulatif). Chaque acteur impliqué voit
      // sa commande à partir du moment où il a passé la main, jusqu'à l'intégration M3 (done_m3) :
      // - client (origine)    : wait_n2, wait_n1, locked, wait_m3
      // - N2 (de ce customer) : wait_n1, locked, wait_m3   (wait_n2 = son "à valider")
      // - N1 (de ce customer) : locked, wait_m3            (wait_n1 = son "à valider")
      // - admin               : locked, wait_m3            (wait_n2/wait_n1 = son "à valider")
      // Les perms AW garantissent qu'on n'a en lecture QUE les commandes où on est impliqué : il
      // suffit donc de prendre les statuts soumis/verrouillés et d'exclure ce qui est dans MON "à valider".
      setFilteredSubmittedOrders(
         live_unsync_orders
            ?.filter((an_order) => {
               if (!isRetailOrder(an_order)) return false
               if (!orderMatchesSearch(an_order, searchText, searchMode === search_type.sku)) return false
               const s = an_order.status
               const isSubmitted = s === order_status.wait_n2 || s === order_status.wait_n1 || s === order_status.locked || s === order_status.wait_m3
               if (!isSubmitted) return false
               const r = roleForOrder(an_order.customer_id)
               const inPending = (r.isAdmin && (s === order_status.wait_n1 || s === order_status.wait_n2)) || (r.isN1 && s === order_status.wait_n1) || (r.isN2 && s === order_status.wait_n2)
               return !inPending
            })
            .sort(sortOrders)
      )
      setFilteredTemplateOrders(
         live_unsync_orders
            ?.filter((an_order) => {
               if (an_order.customer_id.startsWith(glob_const.prefix_prospect)) return true
               if (an_order.customer_id.startsWith(glob_const.prefix_ktm)) {
                  const r = roleForOrder(an_order.customer_id)
                  return r.isAdmin || r.isN1
               }
               return false
            })
            .sort(sortOrders)
      )
   }, [live_unsync_orders, roleForOrder, type_order, order_status, isRetailOrder, orderMatchesSearch, searchText, searchMode])

   const prepShowDropDown = useCallback(
      async (id) => {
         setShowCreateMenu(false)
         if (id !== null) {
            setShowDropdownMenuOnOrderId(id)
            setLastPickedOrderId(id)
            const order = await getOrderById(id)
            setSelectedOrder(order)
            setLastPickedOrderCustId(order.customer_id)
         } else {
            setShowDropdownMenuOnOrderId(null)
            setSelectedOrder(null)
         }
      },
      [getOrderById]
   )

   const onSearchChange = useCallback(
      (text) => {
         setSearchText(text.trim())
      },
      [setSearchText]
   )

   const onSelect = useCallback(
      async (id) => {
         // console.log('ID>>', id, showDropdownMenuOnCustomerId);
         prepShowDropDown(null)
         if (id === menu_items.setActive) {
            setOrderIdAsCurrent(showDropdownMenuOnOrderId)
         } else if (id === menu_items.doEdit) {
            // Une commande soumise/verrouillée se consulte mais ne devient pas la commande courante.
            const ord = await getOrderById(showDropdownMenuOnOrderId)
            if (ord && !isOrderSubmittedOrLocked(ord.status)) setCurOrder(showDropdownMenuOnOrderId)
            updateRecentOrders(showDropdownMenuOnOrderId)
            navigate(`/order-detail?id=${showDropdownMenuOnOrderId}`, { replace: false })
         } else if (id === menu_items.doSee) {
            // Consultation seule : on ouvre le détail SANS sélectionner (comme un clic sur la ligne).
            updateRecentOrders(showDropdownMenuOnOrderId)
            navigate(`/order-detail?id=${showDropdownMenuOnOrderId}`, { replace: false })
         } else if (id === menu_items.doClone) {
            const order = await getOrderById(showDropdownMenuOnOrderId)
            if (order && (isKOTOrder(order) || isKTMOrder(order))) {
               // KOT/KTM : ouvrir l'éditeur pour choisir une nouvelle contremarque (unique)
               setQuotaInitialMark(order.mark ?? null)
               setQuotaIsKOT(isKOTOrder(order))
               setQuotaCloneSourceId(order.id)
               setQuotaCloneTargetCustomerId(order.customer_id)
               setShowQuotaMarkEditor(true)
            } else {
               cloneOrder(showDropdownMenuOnOrderId)
               setCurOrderType((order as any)?.customer_id?.startsWith(glob_const.prefix_prospect) ? tabs.templates : tabs.unsync)
            }
         } else if (id === menu_items.doCloneToDefaultCustomer) {
            cloneOrder(showDropdownMenuOnOrderId, default_customer.id)
            setCurOrderType(tabs.unsync)
         } else if (id === menu_items.doDeployKTM) {
            const order = await getOrderById(showDropdownMenuOnOrderId)
            if (order && isKTMOrder(order)) {
               setKtmToDeploy(order)
               setShowKtmDeployer(true)
            }
         } else if (id === menu_items.doUnDeployKTM) {
            const order = await getOrderById(showDropdownMenuOnOrderId)
            if (order && isKTMOrder(order)) {
               const clientType = extractClientTypeFromKTMMark(order.mark ?? null)
               const period = extractPeriodFromKTMMark(order.mark ?? null)
               if (!clientType || !period) {
                  toast.error(trans('?Période invalide sur le KTM'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
               } else {
                  // Liste des clients éligibles (même type) qui ont un KOT pour cette période
                  const eligible = (getCustomersAsSortedArray() as Customer[]).filter((c) => {
                     if (!c.groupe_client) return false
                     if (c.id?.startsWith(glob_const.prefix_ktm) || c.id?.startsWith(glob_const.prefix_prospect)) return false
                     const grp = (glob_const.customer_groups as Record<string, { type: string }>)[c.groupe_client]
                     return grp?.type === clientType
                  })
                  const affected: Customer[] = []
                  for (const c of eligible) {
                     const kot = await findKOTByPeriod(c.id!, period)
                     if (kot) affected.push(c)
                  }
                  setUnDeployKtm(order)
                  setUnDeployAffected(affected)
                  setUnDeployCheckedIds(affected.map((c) => c.id!)) // par défaut, tous cochés
               }
            }
         } else if (id === menu_items.sendPdf) {
            setIsMailAddressPickerVisible(true)
         } else if (id === menu_items.doDelete) {
            setDeleteOrderId(showDropdownMenuOnOrderId)
            setIsConfirmDeleteVisible(true)
         } else if (id === menu_items.doSync) {
            // Flux unique : popup de confirmation puis soumission (retail) / synchronisation (classique).
            const order = await getOrderById(showDropdownMenuOnOrderId)
            requestSubmit(order)
         } else if (id === menu_items.doValidateN2) {
            const order = await getOrderById(showDropdownMenuOnOrderId)
            // N2 valide → webhook validate-n2 (le serveur décide wait_n1 ou locked + perms).
            // Reliquat proposé UNIQUEMENT si cette validation va en 'locked' = pas de N1 derrière.
            const orderHasN1 = order ? hasN1Validator(order, getCustomerById(order.customer_id)) : false
            if (!orderHasN1 && order?.original_lines && isRetailOrder(order)) {
               const refused = computeRefusedLines(order.original_lines, order.lines)
               if (refused.length > 0) {
                  const currentMap = new Map(order.lines.map((l) => [l.sku, l.qty]))
                  const origMap = new Map(order.original_lines.map((l) => [l.sku, l.qty]))
                  setRefusedLinesForPopup(refused.map((r) => ({ sku: r.sku, label: getRetailModelById(r.sku)?.label ?? '', origQty: origMap.get(r.sku) ?? 0, curQty: currentMap.get(r.sku) ?? 0, reliquat: r.qty })))
                  setCheckedRefusedLines(refused.map(() => true))
                  setValidateOrderId(showDropdownMenuOnOrderId)
                  setValidateOrder(order)
                  setValidateMode('n2')
                  setShowValidateConfirm(true)
               } else {
                  await validateRetailN2(order)
               }
            } else {
               await validateRetailN2(order)
            }
         } else if (id === menu_items.doValidateN1) {
            const order = await getOrderById(showDropdownMenuOnOrderId)
            requestFinalValidation(order) // flux unique : confirmation (+ reliquat) puis validateRetailN1
         } else if (id === menu_items.doUnlock || id === menu_items.doSendToClient) {
            // Flux unique « Renvoyer au client » (confirmation + dispatch new_mgr / wait_n*).
            const order = await getOrderById(showDropdownMenuOnOrderId)
            requestReturnToClient(order, () => {
               setCurOrder(null)
               navigate(id === menu_items.doSendToClient ? '/orders?tab=unsync' : '/orders?tab=pending', { replace: true })
            })
         }
      },
      [
         prepShowDropDown,
         setOrderIdAsCurrent,
         showDropdownMenuOnOrderId,
         setCurOrder,
         updateRecentOrders,
         navigate,
         getOrderById,
         cloneOrder,
         default_customer,
         isRetailOrder,
         isKOTOrder,
         isKTMOrder,
         computeRefusedLines,
         getRetailModelById,
         extractClientTypeFromKTMMark,
         extractPeriodFromKTMMark,
         findKOTByPeriod,
         getCustomersAsSortedArray,
         trans,
         validateRetailN2,
         requestReturnToClient,
         requestFinalValidation,
         requestSubmit,
         isOrderSubmittedOrLocked,
         hasN1Validator,
         getCustomerById
      ]
   )

   async function onConfirmDeleteOK() {
      setIsConfirmDeleteVisible(false)
      deleteOrder(deleteOrderId)
      setDeleteOrderId(null)
   }

   function onConfirmDeleteCancel() {
      setIsConfirmDeleteVisible(false)
      setDeleteOrderId(null)
   }

   async function onConfirmSyncOK() {
      setIsConfirmSyncVisible(false)
      // Synchroniser ne s'applique PAS aux ECR/ECF (qui passent par "Soumettre").
      for (const an_order of allUnsyncOrders) {
         if (unsyncLinesChecked.has(an_order.id) && !isRetailOrder(an_order) && canSyncOrder(an_order)) {
            await updateOrder(an_order.id, {
               status: order_status.locked4sync, // On va essayer de la pousser sur AppWrite (c'est updateOrder qui s'en charge, elle va ensuite passer en locked)
               readonly: true
            })
         }
      }
   }

   function onConfirmSyncCancel() {
      setIsConfirmSyncVisible(false)
   }

   async function onConfirmSubmitOK() {
      setIsConfirmSubmitVisible(false)
      // Soumettre s'applique aux ECR/ECF cochées (webhook submit → wait_n2/wait_n1/error décidé serveur-side).
      for (const an_order of allUnsyncOrders) {
         if (unsyncLinesChecked.has(an_order.id) && isRetailOrder(an_order) && canSyncOrder(an_order)) {
            await submitRetailOrder(an_order)
         }
      }
   }

   function onConfirmSubmitCancel() {
      setIsConfirmSubmitVisible(false)
   }

   async function onValidateConfirmOK() {
      if (validateOrderId && validateOrder) {
         // Lignes refusées cochées à reporter en reliquat : transmises au webhook, qui crée le reliquat
         // côté serveur (perms client+admins) UNIQUEMENT si la validation produit 'locked'.
         const reliquatLines = refusedLinesForPopup.filter((_, i) => checkedRefusedLines[i]).map((r) => ({ sku: r.sku, qty: r.reliquat }))
         if (validateMode === 'n2') {
            await validateRetailN2(validateOrder, reliquatLines)
         } else {
            await validateRetailN1(validateOrder, reliquatLines)
         }
      }
      setShowValidateConfirm(false)
      setValidateOrderId(null)
      setValidateOrder(null)
      setValidateMode(null)
   }

   function onValidateConfirmCancel() {
      setShowValidateConfirm(false)
      setValidateOrderId(null)
      setValidateOrder(null)
      setValidateMode(null)
   }

   const closeAllDropDowns = useCallback(() => {
      let ret = false

      if (showDropdownMenuGlobal) {
         setShowDropdownMenuGlobal(false)
         ret = true
      }
      if (showDropdownMenuOnOrderId) {
         setShowDropdownMenuOnOrderId(null)
         ret = true
      }
      if (showCreateMenu) {
         setShowCreateMenu(false)
         ret = true
      }
      return ret
   }, [showDropdownMenuGlobal, showDropdownMenuOnOrderId, showCreateMenu])

   const onSelAllChange = useCallback(
      (state) => {
         closeAllDropDowns()
         if (allUnsyncOrders && state) {
            setUnsyncLinesChecked(new Set(allUnsyncOrders.map((an_order) => an_order.id)))
         } else {
            setUnsyncLinesChecked(new Set())
         }
      },
      [allUnsyncOrders, closeAllDropDowns]
   )

   // Drapeaux dérivés : pour activer / désactiver "Soumettre" (ECR/ECF) vs "Synchroniser" (non-retail).
   const hasCheckedRetail = useMemo(() => {
      if (!allUnsyncOrders) return false
      return allUnsyncOrders.some((o) => unsyncLinesChecked.has(o.id) && isRetailOrder(o))
   }, [allUnsyncOrders, unsyncLinesChecked, isRetailOrder])
   // Nb de commandes retail cochées (singulier/pluriel de la confirmation de soumission) — utilitaire commun.
   const nbCheckedRetail = useMemo(() => countCheckedRetail(allUnsyncOrders, unsyncLinesChecked), [countCheckedRetail, allUnsyncOrders, unsyncLinesChecked])
   const hasCheckedNonRetail = useMemo(() => {
      if (!allUnsyncOrders) return false
      return allUnsyncOrders.some((o) => unsyncLinesChecked.has(o.id) && !isRetailOrder(o))
   }, [allUnsyncOrders, unsyncLinesChecked, isRetailOrder])

   useEffect(() => {
      if (allUnsyncOrders) {
         setUnsyncLinesAllChecked(allUnsyncOrders.length === unsyncLinesChecked.size)
         setUnsyncLinesNoneChecked(unsyncLinesChecked.size === 0)
      } else {
         setUnsyncLinesAllChecked(false)
         setUnsyncLinesNoneChecked(true)
      }
      // if (allSyncOrders) {
      //    setSyncLinesAllChecked(allSyncOrders.length === syncLinesChecked.size)
      //    setSyncLinesNoneChecked(syncLinesChecked.size === 0)
      // } else {
      //    setSyncLinesAllChecked(false)
      //    setSyncLinesNoneChecked(true)
      // }
   }, [allUnsyncOrders, unsyncLinesChecked.size])

   const onShowMenu = useCallback(
      (evt, id) => {
         evt.stopPropagation()
         if (showDropdownMenuOnOrderId === id) {
            prepShowDropDown(null)
         } else {
            prepShowDropDown(id)
         }
      },
      [prepShowDropDown, showDropdownMenuOnOrderId]
   )

   const onChangeChoice = useCallback(
      (id, state, type) => {
         // console.log(
         //    `Item ${id}${state === CheckboxStates.Checked ? 'Checked' : 'Unchecked'
         //    }`
         // )
         if (type === order_status.new) {
            setUnsyncLinesChecked((cur) => {
               if (state === CheckboxStates.Checked) {
                  return new Set([...cur, id])
               } else {
                  return new Set([...cur].filter((an_id) => an_id !== id))
               }
            })
         }
         // else {
         //    setSyncLinesChecked(cur => {
         //       if (state === CheckboxStates.Checked) {
         //          return new Set([...cur, id])
         //       } else {
         //          return new Set([...cur].filter(an_id => an_id !== id))
         //       }
         //    })
         // }
      },
      [order_status.new]
   )

   const onLineClick = useCallback(
      (evt, num) => {
         // console.log('doNothing')
         evt.stopPropagation()
         if (showDropdownMenuOnOrderId !== null) {
            prepShowDropDown(null)
         } else {
            updateRecentOrders(num)
            navigate(`/order-detail?id=${num}`, { replace: false })
         }
      },
      [navigate, prepShowDropDown, showDropdownMenuOnOrderId, updateRecentOrders]
   )

   // Onglet DEBUG « Quotas (debug) » : les KOT, rendus comme n'importe quelle commande via buildLines.
   // Filtré par rôle per-customer (admin/N1 du client de la commande) comme l'onglet Quotas normal —
   // sinon un N1 verrait en debug les KOT de clients qu'il ne supervise pas. Affiché uniquement en debug.
   const filteredKotOrders = useMemo(
      () => (live_unsync_orders ?? []).filter((o) => {
         if (o.type !== type_order.retail_quota) return false
         const r = roleForOrder(o.customer_id)
         if (!(r.isAdmin || r.isN1)) return false
         return orderMatchesSearch(o, searchText, searchMode === search_type.sku)
      }),
      [live_unsync_orders, type_order.retail_quota, roleForOrder, orderMatchesSearch, searchText, searchMode]
   )

   const buildLines = useCallback(
      (template, status) => {
         let arr, checkboxes

         if (status === 'pending') {
            arr = curPagePendingOrders
            checkboxes = null
         } else if (status === 'submitted') {
            arr = curPageSubmittedOrders
            checkboxes = null
         } else if (status === 'quotas') {
            arr = curPageQuotaOrders
            checkboxes = null
         } else if (status === 'kotdebug') {
            arr = filteredKotOrders
            checkboxes = null
         } else if (status === order_status.new) {
            arr = template ? curPageTemplateOrders : curPageUnsyncOrders
            checkboxes = unsyncLinesChecked
         } else {
            arr = curPageSyncOrders
            // checkboxes = syncLinesChecked
         }
         // console.log(arr);
         const isTemplateCustomer = (id: string) => id.startsWith(glob_const.prefix_prospect) || id.startsWith(glob_const.prefix_ktm)
         return arr
            ?.filter((an_order) => {
               return template ? isTemplateCustomer(an_order.customer_id) : !isTemplateCustomer(an_order.customer_id)
            })
            .map((an_order) => {
               const a_customer = getCustomerById(an_order.customer_id)

               // console.log(a_customer);
               // Tout est valorisé en CESSION (retail ECR/ECF comme commandes classiques) → devise cession.
               const devise = a_customer?.tarifs?.ces?.currency
               // console.log(checkboxes, curOrderType)
               // La technique du foundOme dans les unsync n'était pas ok car si la commande a été créée sur un autre ordi ou qu'il y a eu purge, on ne la trouve plus.
               // const found_oMe = allUnsyncOrders.find(an_ome_order => an_ome_order.m3_number === an_order.id)
               // J'ai maintenant un champ qui provient de la BI
               const found_oMe = an_order?.ome_doc_id ? (glob_const.regex_ome_doc_id.test(an_order.ome_doc_id) ? an_order.ome_doc_id : null) : null
               return (
                  <tr
                     key={`line_${an_order.id}`}
                     className={an_order.id === curOrder ? styles.selected : ''}
                     onClick={(evt) => {
                        onLineClick(evt, an_order.id)
                     }}
                  >
                     {curOrderType === tabs.unsync && checkboxes && (
                        <td className={styles.checkbox}>
                           <div>
                              {/* <Checkbox small light checked={(an_order.id === curOrder) ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={(state) => onChangeChoice(an_order.id, state)} /> */}
                              <Checkbox small light checked={checkboxes.has(an_order.id) ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={(state) => onChangeChoice(an_order.id, state, status)} />
                           </div>
                        </td>
                     )}
                     <td className={styles.order_type}>
                        <div>
                           {an_order.type === type_order.commande && <FontAwesomeIcon icon={faGem} />}
                           {an_order.type === type_order.implant && <FontAwesomeIcon icon={faShelves} />}
                           {an_order.type === type_order.confie && <FontAwesomeIcon icon={faHandHoldingBox} />}
                           {an_order.type === type_order.triangulaire && <FontAwesomeIcon icon={faRecycle} />}
                           {an_order.type === type_order.devis && <FontAwesomeIcon icon={faFilePen} />}
                           {isRetailOrder(an_order) && <FontAwesomeIcon icon={faBox} />}
                           {isKOTOrder(an_order) && <FontAwesomeIcon icon={faScaleBalanced} />}
                           {isKTMOrder(an_order) && <FontAwesomeIcon icon={faObjectGroup} />}
                           <span>{an_order.type}</span>
                        </div>
                     </td>
                     <td className={styles.num_order}>
                        <div>
                           <span>{an_order.id}</span>
                           {an_order.mark && (
                              <span>
                                 <FontAwesomeIcon icon={faBookmark} />
                                 {an_order.mark}
                              </span>
                           )}
                        </div>
                     </td>
                     {curOrderType === tabs.sync && (
                        <td className={styles.num_ome}>
                           {found_oMe && (
                              <>
                                 <span>{found_oMe}</span>
                                 <div className={styles.green}>
                                    {' '}
                                    {/* Envoyé vers M3 */}
                                    <FontAwesomeIcon icon={faCloud} />
                                 </div>
                              </>
                           )}
                        </td>
                     )}
                     <td className={styles.name}>
                        <div>
                           <span style={a_customer?.id?.startsWith(glob_const.prefix_ktm) || a_customer?.id?.startsWith(glob_const.prefix_prospect) ? { fontStyle: 'italic' } : undefined}>{a_customer?.name ?? '???'}</span>
                           <span>{a_customer?.email ?? '???'}</span>
                        </div>
                     </td>
                     <td className={styles.date}>
                        <div>
                           <span>{an_order.date}</span>
                           {/* {!an_order.readonly && <span>{an_order.time}</span>} */}
                        </div>
                     </td>
                     <td className={styles.total_price}>{formatCESPrice(calcTotalForOrder(an_order), devise)}</td>
                     {curOrderType === tabs.unsync && (
                        <td className={styles.signature}>
                           <div>{an_order.signature && <FontAwesomeIcon icon={faSignature} />}</div>
                        </td>
                     )}
                     {(status === order_status.new || status === tabs.submitted) && (
                        <td className={styles.sync}>
                           {an_order.status !== order_status.new && an_order.status !== order_status.new_mgr && an_order.status !== order_status.deleted && an_order.status !== order_status.locked4sync && (
                              <div className={styles.green}>
                                 {/* User-client retail en attente de validation : loupe-user au lieu du nuage (cf. hideRetailWorkflow) */}
                                 <FontAwesomeIcon icon={isUnderRetailReview(an_order) ? faUserMagnifyingGlass : faCloud} />
                                 {/* lock_n* = transit en attente d'attribution batch, wait_n* = attribué + en attente de validation.
                               On affiche N1/N2 dans les 2 cas pour montrer où la commande est dans le workflow. */}
                                 {!hideRetailWorkflow(an_order) && an_order.status === order_status.wait_n1 && <span>N1</span>}
                                 {!hideRetailWorkflow(an_order) && an_order.status === order_status.wait_n2 && <span>N2</span>}
                                 {/* Retail en route vers M3 (workflow terminé N1/N2 → locked, ou en file d'intégration → wait_m3) */}
                                 {!hideRetailWorkflow(an_order) && isRetailOrder(an_order) && (an_order.status === order_status.locked || an_order.status === order_status.wait_m3) && <span>M3</span>}
                              </div>
                           )}
                           {an_order.status === order_status.locked4sync && (
                              <div className={styles.orange}>
                                 <FontAwesomeIcon icon={faCloudXmark} />
                              </div>
                           )}
                           {an_order.status === order_status.deleted && (
                              <div className={styles.red}>
                                 <FontAwesomeIcon icon={faTrashXmark} />
                              </div>
                           )}
                        </td>
                     )}
                     <td className={styles.actions}>
                        <span onClick={(evt) => onShowMenu(evt, an_order.id)}>
                           {/* <FontAwesomeIcon icon={faGear} /> */}
                           {trans('?Détail', true)}
                           <FontAwesomeIcon icon={faAngleRight} />
                           {showDropdownMenuOnOrderId === an_order.id ? dropdownMenu : ''}
                        </span>
                     </td>
                  </tr>
               )
            })
      },
      [
         calcTotalForOrder,
         curOrder,
         curOrderType,
         curPagePendingOrders,
         curPageQuotaOrders,
         curPageSubmittedOrders,
         curPageSyncOrders,
         curPageTemplateOrders,
         curPageUnsyncOrders,
         dropdownMenu,
         formatCESPrice,
         getCustomerById,
         hideRetailWorkflow,
         isRetailOrder,
         isKOTOrder,
         isKTMOrder,
         isUnderRetailReview,
         onChangeChoice,
         onLineClick,
         onShowMenu,
         order_status,
         showDropdownMenuOnOrderId,
         trans,
         type_order.commande,
         type_order.confie,
         type_order.devis,
         type_order.implant,
         type_order.triangulaire,
         unsyncLinesChecked,
         filteredKotOrders
      ]
   )

   /**********************
    * Commun SYNC + UNSYNC
    **********************/

   // Réinitialise les filtres devenus non pertinents selon le périmètre catalogue,
   // pour qu'un filtre masqué resté actif ne fausse pas le filtrage inclusif ci-dessous.
   //  - retail-only : les filtres de type bijoux (CDE/CDI/CON/DEV/oMe) sont masqués.
   //  - hors mode mixte : le filtre RET (ECR+ECF) n'a pas de sens.
   useEffect(() => {
      if (isRetailOnly) {
         setFilterCDE(false)
         setFilterCDI(false)
         setFilterCON(false)
         setFilterTRI(false)
         setFilterDEV(false)
         setFilterOME(false)
      }
      if (!hasBoth) setFilterRET(false)
   }, [isRetailOnly, hasBoth])

   // SYNCed orders
   useEffect(() => {
      let arr
      const str = searchText?.trim().toLowerCase()
      if (str) {
         arr = allSyncOrders?.filter((an_order) => orderMatchesSearch(an_order, searchText, searchMode === search_type.sku))
      } else if (!filterCDE && !filterCDI && !filterCON && !filterTRI && !filterRET) {
         if (filterOME) {
            arr = allSyncOrders?.filter((an_order) => glob_const.regex_ome_doc_id.test(an_order.ome_doc_id))
         } else {
            arr = allSyncOrders
         }
      } else {
         arr = allSyncOrders?.filter((an_order) => {
            if (filterOME) {
               if (!glob_const.regex_ome_doc_id.test(an_order.ome_doc_id)) {
                  return false
               }
            }
            if (filterCDE && an_order.type === type_order.commande) {
               return true
            }
            if (filterCDI && an_order.type === type_order.implant) {
               return true
            }
            if (filterTRI && an_order.type === type_order.triangulaire) {
               return true
            }
            if (filterCON && an_order.type === type_order.confie) {
               return true
            }
            if (filterRET && isRetailOrder(an_order)) {
               return true
            }
            return false
         })
      }
      setFilteredSyncOrders(arr)
   }, [allSyncOrders, filterCDE, filterCDI, filterCON, filterTRI, filterOME, filterRET, isRetailOrder, orderMatchesSearch, searchMode, searchText, type_order])

   // UNSYNCed orders
   useEffect(() => {
      let arr
      const str = searchText?.trim().toLowerCase()
      if (str) {
         arr = allUnsyncOrders?.filter((an_order) => orderMatchesSearch(an_order, searchText, searchMode === search_type.sku))
      } else if (!filterCDE && !filterCDI && !filterCON && !filterTRI && !filterDEV && !filterRET) {
         arr = allUnsyncOrders
      } else {
         arr = allUnsyncOrders?.filter((an_order) => {
            if (filterCDE && an_order.type === type_order.commande) {
               return true
            }
            if (filterCDI && an_order.type === type_order.implant) {
               return true
            }
            if (filterTRI && an_order.type === type_order.triangulaire) {
               return true
            }
            if (filterCON && an_order.type === type_order.confie) {
               return true
            }
            if (filterDEV && an_order.type === type_order.devis) {
               return true
            }
            if (filterRET && isRetailOrder(an_order)) {
               return true
            }
            return false
         })
      }
      setFilteredUnsyncOrders(arr)
   }, [allUnsyncOrders, filterCDE, filterCDI, filterCON, filterTRI, filterDEV, filterRET, isRetailOrder, orderMatchesSearch, searchMode, searchText, type_order])

   useEffect(() => {
      setUnsyncLines(buildLines(false, order_status.new))
      setSyncLines(buildLines(false, undefined))
      setTemplateLines(buildLines(true, order_status.new))
      setPendingLines(buildLines(false, 'pending'))
      setQuotaLines(buildLines(false, 'quotas'))
      setSubmittedLines(buildLines(false, 'submitted'))
      setKotDebugLines(buildLines(false, 'kotdebug'))
   }, [buildLines, order_status])

   /*******************
    * UNSYNC
    *******************/

   useEffect(() => {
      const start = (curPageUnsync - 1) * listPageLength
      setCurPageUnsyncOrders(filteredUnsyncOrders?.slice(start, start + listPageLength))
      setCountFailedSyncOrders(
         filteredUnsyncOrders?.reduce((prev, order) => {
            if (order.status === order_status.locked4sync || order.status === order_status.deleted) {
               return prev + 1
            } else {
               return prev
            }
         }, 0) ?? 0
      )
   }, [curPageUnsync, filteredUnsyncOrders, listPageLength, order_status])

   // useEffect(() => {
   //    // Vérifie que le choix affichage "tous" dans la page est compatible avec le nb de ligne
   //    setListPageLength(cur => {
   //       if ((cur > 100) && ((filteredSyncOrders?.length > 1000) || (filteredUnsyncOrders?.length > 1000))) {
   //          console.log('Liste trop longue pour mode "tous"!')
   //          return 100
   //       } else {
   //          return cur
   //       }
   //    })
   // }, [filteredSyncOrders, filteredUnsyncOrders, setListPageLength])

   useEffect(() => {
      let pageLength = listPageLength

      if (pageLength <= 0) {
         pageLength = 1
         console.error(`Erreur ListPageLength ! ${listPageLength} - Modifié temporairement en 1`)
      }

      let max = Math.max(1, Math.floor((filteredUnsyncOrders?.length + pageLength - 1) / pageLength)) // Nb maxi de pages
      setNbPagesUnsync(max)
      if (curPageUnsync < 1 || curPageUnsync > max) {
         setCurPageUnsync(1)
      }
   }, [curPageUnsync, filteredUnsyncOrders, listPageLength])

   const onFirstPageChangeUnsync = useCallback((val) => {
      console.log('onFirstPageChangeUnsync', val)
      setFirstPageUnsync(val)
   }, [])

   const onPageChangeUnsync = useCallback((val) => {
      console.log('onPageChangeUnsync', val)
      setCurPageUnsync(val)
   }, [])

   useEffect(() => {
      setPagesButtonsUnsync(<PagesButtons from={firstPageUnsync} max={nbPagesUnsync} selected={curPageUnsync} onFirstPageChange={onFirstPageChangeUnsync} onPageChange={onPageChangeUnsync}></PagesButtons>)
   }, [curPageUnsync, firstPageUnsync, nbPagesUnsync, onFirstPageChangeUnsync, onPageChangeUnsync])

   /*******************
    * TEMPLATE
    *******************/

   useEffect(() => {
      const start = (curPageTemplates - 1) * listPageLength
      setCurPageTemplateOrders(filteredTemplateOrders?.slice(start, start + listPageLength))
   }, [curPageTemplates, filteredTemplateOrders, listPageLength])

   useEffect(() => {
      let pageLength = listPageLength

      if (pageLength <= 0) {
         pageLength = 1
         console.error(`Erreur ListPageLength ! ${listPageLength} - Modifié temporairement en 1`)
      }

      let max = Math.max(1, Math.floor((filteredTemplateOrders?.length + pageLength - 1) / pageLength)) // Nb maxi de pages
      setNbPagesTemplates(max)
      if (curPageTemplates < 1 || curPageTemplates > max) {
         setCurPageTemplates(1)
      }
   }, [curPageTemplates, filteredTemplateOrders, listPageLength])

   const onFirstPageChangeTemplates = useCallback((val) => {
      console.log('onFirstPageChangeTemplates', val)
      setFirstPageTemplates(val)
   }, [])

   const onPageChangeTemplates = useCallback((val) => {
      console.log('onPageChangeTemplates', val)
      setCurPageTemplates(val)
   }, [])

   useEffect(() => {
      setPagesButtonsTemplates(<PagesButtons from={firstPageTemplates} max={nbPagesTemplates} selected={curPageTemplates} onFirstPageChange={onFirstPageChangeTemplates} onPageChange={onPageChangeTemplates}></PagesButtons>)
   }, [curPageTemplates, firstPageTemplates, nbPagesTemplates, onFirstPageChangeTemplates, onPageChangeTemplates])

   /*******************
    * PENDING (À valider)
    *******************/

   useEffect(() => {
      const start = (curPagePending - 1) * listPageLength
      setCurPagePendingOrders(filteredPendingOrders?.slice(start, start + listPageLength))
   }, [curPagePending, filteredPendingOrders, listPageLength])

   useEffect(() => {
      let pageLength = listPageLength
      if (pageLength <= 0) pageLength = 1
      let max = Math.max(1, Math.floor((filteredPendingOrders?.length + pageLength - 1) / pageLength))
      setNbPagesPending(max)
      if (curPagePending < 1 || curPagePending > max) {
         setCurPagePending(1)
      }
   }, [curPagePending, filteredPendingOrders, listPageLength])

   const onFirstPageChangePending = useCallback((val) => {
      setFirstPagePending(val)
   }, [])

   const onPageChangePending = useCallback((val) => {
      setCurPagePending(val)
   }, [])

   useEffect(() => {
      setPagesButtonsPending(<PagesButtons from={firstPagePending} max={nbPagesPending} selected={curPagePending} onFirstPageChange={onFirstPageChangePending} onPageChange={onPageChangePending} />)
   }, [curPagePending, firstPagePending, nbPagesPending, onFirstPageChangePending, onPageChangePending])

   /*******************
    * SUBMITTED (Soumises)
    *******************/

   useEffect(() => {
      const start = (curPageSubmitted - 1) * listPageLength
      setCurPageSubmittedOrders(filteredSubmittedOrders?.slice(start, start + listPageLength))
   }, [curPageSubmitted, filteredSubmittedOrders, listPageLength])

   useEffect(() => {
      let pageLength = listPageLength
      if (pageLength <= 0) pageLength = 1
      let max = Math.max(1, Math.floor((filteredSubmittedOrders?.length + pageLength - 1) / pageLength))
      setNbPagesSubmitted(max)
      if (curPageSubmitted < 1 || curPageSubmitted > max) {
         setCurPageSubmitted(1)
      }
   }, [curPageSubmitted, filteredSubmittedOrders, listPageLength])

   const onFirstPageChangeSubmitted = useCallback((val) => {
      setFirstPageSubmitted(val)
   }, [])

   const onPageChangeSubmitted = useCallback((val) => {
      setCurPageSubmitted(val)
   }, [])

   useEffect(() => {
      setPagesButtonsSubmitted(<PagesButtons from={firstPageSubmitted} max={nbPagesSubmitted} selected={curPageSubmitted} onFirstPageChange={onFirstPageChangeSubmitted} onPageChange={onPageChangeSubmitted} />)
   }, [curPageSubmitted, firstPageSubmitted, nbPagesSubmitted, onFirstPageChangeSubmitted, onPageChangeSubmitted])

   /*******************
    * QUOTAS (KOT/KTM)
    *******************/

   useEffect(() => {
      const start = (curPageQuotas - 1) * listPageLength
      setCurPageQuotaOrders(filteredQuotaOrders?.slice(start, start + listPageLength))
   }, [curPageQuotas, filteredQuotaOrders, listPageLength])

   useEffect(() => {
      let pageLength = listPageLength
      if (pageLength <= 0) pageLength = 1
      const max = Math.max(1, Math.floor(((filteredQuotaOrders?.length ?? 0) + pageLength - 1) / pageLength))
      setNbPagesQuotas(max)
      if (curPageQuotas < 1 || curPageQuotas > max) {
         setCurPageQuotas(1)
      }
   }, [curPageQuotas, filteredQuotaOrders, listPageLength])

   const onFirstPageChangeQuotas = useCallback((val) => {
      setFirstPageQuotas(val)
   }, [])

   const onPageChangeQuotas = useCallback((val) => {
      setCurPageQuotas(val)
   }, [])

   useEffect(() => {
      setPagesButtonsQuotas(<PagesButtons from={firstPageQuotas} max={nbPagesQuotas} selected={curPageQuotas} onFirstPageChange={onFirstPageChangeQuotas} onPageChange={onPageChangeQuotas} />)
   }, [curPageQuotas, firstPageQuotas, nbPagesQuotas, onFirstPageChangeQuotas, onPageChangeQuotas])

   /*******************
    * SYNC
    *******************/

   useEffect(() => {
      const start = (curPageSync - 1) * listPageLength
      // console.log(filteredSyncOrders, start, listPageLength);
      setCurPageSyncOrders(filteredSyncOrders?.slice(start, start + listPageLength))
   }, [curPageSync, filteredSyncOrders, listPageLength])

   useEffect(() => {
      let pageLength = listPageLength

      if (pageLength <= 0) {
         pageLength = 1
         console.error(`Erreur ListPageLength ! ${listPageLength} - Modifié temporairement en 1`)
      }

      let max = Math.max(1, Math.floor((filteredSyncOrders?.length + pageLength - 1) / pageLength)) // Nb maxi de pages
      setNbPagesSync(max)
      // console.log('>>', filteredSyncOrders, max, curPageSync);
      if (curPageSync < 1 || curPageSync > max) {
         setCurPageSync(1)
      }
   }, [curPageSync, filteredSyncOrders, listPageLength])

   // useEffect(() => {
   //    const start = (curPageSync - 1) * listPageLength
   //    setCurPageSyncOrders(allSyncOrders?.slice(start, start + listPageLength))
   // }, [allSyncOrders, curPageSync, listPageLength])

   const onFirstPageChangeSync = useCallback((val) => {
      console.log('onFirstPageChangeSync', val)
      setFirstPageSync(val)
   }, [])

   const onPageChangeSync = useCallback((val) => {
      console.log('onPageChangeSync', val)
      setCurPageSync(val)
   }, [])

   useEffect(() => {
      // console.log(curPageSync, firstPageSync, nbPagesSync);
      setPagesButtonsSync(<PagesButtons from={firstPageSync} max={nbPagesSync} selected={curPageSync} onFirstPageChange={onFirstPageChangeSync} onPageChange={onPageChangeSync}></PagesButtons>)
   }, [curPageSync, firstPageSync, nbPagesSync, onFirstPageChangeSync, onPageChangeSync])

   /************************
    * FIN DES SYNC ET UNSYNC
    ************************/

   useEffect(() => {
      setDropdownMenu(
         <DropdownMenu noscrollbars right={-20} top={20} onSelect={onSelect}>
            {(() => {
               const canEditRetail =
                  isRetailOrder(selectedOrder) &&
                  ((roleForSelected.isN2 && selectedOrder?.status === order_status.wait_n2) || ((roleForSelected.isN1 || roleForSelected.isAdmin) && (selectedOrder?.status === order_status.wait_n1 || selectedOrder?.status === order_status.wait_n2)))
               // Onglet « Soumises » : la commande nous a quittés → ni Modifier ni Sélectionner (consultation seule).
               // KOT : sélection/modif réservées à admin/N1 (canWriteKOT) — sinon consultation seule.
               const editable = (!selectedOrder?.readonly || canEditRetail) && curOrderType !== tabs.submitted && canWriteKOT(selectedOrder, roleForSelected)
               return editable ? (
                  <>
                     <li id={menu_items.doEdit}>
                        <FontAwesomeIcon icon={faPenToSquare} />
                        {canEditRetail ? trans('?Ouvrir validation...') : trans('?Modifier')}
                     </li>
                     {/* « Sélectionner » (comme commande courante) seulement si la commande est réellement
                         modifiable par le user : pas une commande soumise/verrouillée (la validation N1/N2
                         se fait via « Ouvrir validation… », pas en la rendant courante). */}
                     {!isOrderSubmittedOrLocked(selectedOrder?.status) && (
                        <li disabled={curOrder === showDropdownMenuOnOrderId} id={menu_items.setActive}>
                           <FontAwesomeIcon icon={faBadgeCheck} />
                           {trans('?Sélectionner')}
                        </li>
                     )}
                  </>
               ) : (
                  <li id={menu_items.doSee}>
                     <FontAwesomeIcon icon={faEye} />
                     {trans('?Voir')}
                  </li>
               )
            })()}
            <li id={menu_items.sendPdf}>
               <FontAwesomeIcon icon={faFilePdf} />
               {trans('?Envoyer en PDF à...')}
            </li>
            {/* Dupliquer un KOT = créer un nouveau quota → réservé admin/N1 (canWriteKOT), comme la création. */}
            {canWriteKOT(selectedOrder, roleForSelected) && (
               <li id={menu_items.doClone}>
                  <FontAwesomeIcon icon={faClone} />
                  {trans('?Dupliquer')}
               </li>
            )}
            {selectedOrder && isKTMOrder(selectedOrder) && canCreateKTM() && (
               <li id={menu_items.doDeployKTM}>
                  <FontAwesomeIcon icon={faObjectGroupLight} />
                  {trans('?Déployer vers clients')}
               </li>
            )}
            {selectedOrder && isKTMOrder(selectedOrder) && canCreateKTM() && (
               <li id={menu_items.doUnDeployKTM}>
                  <FontAwesomeIcon icon={faCircleXmark} />
                  {trans('?Supprimer le déploiement')}
               </li>
            )}
            {default_customer && selectedOrder && !isKTMOrder(selectedOrder) && canWriteKOT(selectedOrder, roleForSelected) && selectedOrder.customer_id !== default_customer.id && (
               <li id={menu_items.doCloneToDefaultCustomer}>
                  <FontAwesomeIcon icon={faClone} />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <span>
                        {trans('?Dupliquer')} {lowtrans('?Vers')}
                     </span>
                     <span>{default_customer.name}</span>
                  </div>
               </li>
            )}
            {!selectedOrder?.readonly && canWriteKOT(selectedOrder, roleForSelected) && (
               <li id={menu_items.doDelete}>
                  <FontAwesomeIcon icon={faTrashCan} />
                  {trans('?Supprimer')}
               </li>
            )}
            {/* Synchroniser (cmd classique) ou Soumettre (Retail user-client) — masqué pour KOT/KTM et pour managers Retail (N1/N2/admin) */}
            {!selectedOrder?.readonly && !isKOTOrder(selectedOrder) && !isKTMOrder(selectedOrder) && !roleForSelected.effectiveRole && (isRetailOrder(selectedOrder) ? retailRole === 'client' : true) && (
               <>
                  <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '6px 0' }} />
                  <li id={menu_items.doSync} disabled={selectedOrder?.status !== order_status.new || (selectedOrder && !canSyncOrder(selectedOrder))}>
                     <FontAwesomeIcon icon={isRetailOrder(selectedOrder) ? faArrowRight : faCloudArrowUp} />
                     {trans(isRetailOrder(selectedOrder) ? '?Soumettre' : '?Synchroniser')}
                  </li>
               </>
            )}
            {/* ───── Bloc workflow Retail manager : Soumission / Validation finale puis RETOUR AU CLIENT
                juste en dessous. Séparateur au-dessus. (Pas de Sauvegarde/Restaurer dans ce menu contextuel.) */}
            {isRetailOrder(selectedOrder) &&
               roleForSelected.effectiveRole &&
               (selectedOrder?.status === order_status.new || selectedOrder?.status === order_status.new_mgr || selectedOrder?.status === order_status.wait_n2 || selectedOrder?.status === order_status.wait_n1) && (
                  <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '6px 0' }} />
               )}
            {/* Soumettre (N2 du customer ; new / new_mgr / wait_n2). Gâté par la complétude (contremarque + adresse). */}
            {isRetailOrder(selectedOrder) && roleForSelected.isN2 && (selectedOrder?.status === order_status.new || selectedOrder?.status === order_status.new_mgr || selectedOrder?.status === order_status.wait_n2) && (
               <li id={menu_items.doValidateN2} disabled={!isOrderComplete(selectedOrder)}>
                  <FontAwesomeIcon icon={faArrowRight} />
                  {trans('?Soumettre')}
               </li>
            )}
            {/* Validation finale (admin ou N1 du customer ; new / new_mgr / wait_n2 / wait_n1). Gâté par la complétude. */}
            {isRetailOrder(selectedOrder) &&
               (roleForSelected.isAdmin || roleForSelected.isN1) &&
               (selectedOrder?.status === order_status.new || selectedOrder?.status === order_status.new_mgr || selectedOrder?.status === order_status.wait_n2 || selectedOrder?.status === order_status.wait_n1) && (
                  <li id={menu_items.doValidateN1} disabled={!isOrderComplete(selectedOrder)}>
                     <FontAwesomeIcon icon={faLock} />
                     {trans('?Validation finale')}
                  </li>
               )}
            {/* Retour au client (sous la soumission/validation) — new_mgr → new via send-to-client.
                Libellé « Envoyer au client » (jamais transmise au client), icône identique aux wait_n*. */}
            {isRetailOrder(selectedOrder) && roleForSelected.effectiveRole && selectedOrder?.status === order_status.new_mgr && (
               <li id={menu_items.doSendToClient}>
                  <FontAwesomeIcon icon={faLockOpen} />
                  {trans('?Envoyer au client')}
               </li>
            )}
            {/* Retour au client (sous la soumission/validation) — wait_n* : Renvoyer au client. Masqué dans « Soumises ». */}
            {curOrderType !== tabs.submitted && isRetailOrder(selectedOrder) && roleForSelected.effectiveRole && (selectedOrder?.status === order_status.wait_n2 || selectedOrder?.status === order_status.wait_n1) && (
               <li id={menu_items.doUnlock}>
                  <FontAwesomeIcon icon={faLockOpen} />
                  {trans('?Renvoyer au client')}
               </li>
            )}
         </DropdownMenu>
      )
      // Filtres de type masqués en retail-only et dans les onglets KOT (quotas/kotdebug,
      // 100% retail) et templates. Le filtre RET (ECR+ECF) n'apparaît qu'en mode mixte.
      const left_toolz = !isRetailOnly && curOrderType !== tabs.templates && curOrderType !== tabs.quotas && curOrderType !== tabs.kotdebug && (
         <div className={styles_Searchbar.left_tools}>
            <button
               className={filterCDE ? styles_Searchbar.state_on : styles_Searchbar.state_off}
               onClick={() => {
                  setFilterCDE((cur) => !cur)
               }}
            >
               <FontAwesomeIcon icon={faGem} />
               <span>CDE</span>
            </button>
            <button
               className={filterCDI ? styles_Searchbar.state_on : styles_Searchbar.state_off}
               onClick={() => {
                  setFilterCDI((cur) => !cur)
               }}
            >
               <FontAwesomeIcon icon={faShelves} />
               <span>CDI</span>
            </button>
            <button
               className={filterCON ? styles_Searchbar.state_on : styles_Searchbar.state_off}
               onClick={() => {
                  setFilterCON((cur) => !cur)
               }}
            >
               <FontAwesomeIcon icon={faHandHoldingBox} />
               <span>CON</span>
            </button>
            {curOrderType === tabs.sync && (
               <button
                  className={filterOME ? styles_Searchbar.state_on : styles_Searchbar.state_off}
                  onClick={() => {
                     setFilterOME((cur) => !cur)
                  }}
               >
                  oMe
               </button>
            )}
            {hasBoth && (
               <button
                  className={filterRET ? styles_Searchbar.state_on : styles_Searchbar.state_off}
                  onClick={() => {
                     setFilterRET((cur) => !cur)
                  }}
               >
                  <FontAwesomeIcon icon={faBox} />
                  <span>ECR·F</span>
               </button>
            )}
            <button
               className={filterTRI ? styles_Searchbar.state_on : styles_Searchbar.state_off}
               onClick={() => {
                  setFilterTRI((cur) => !cur)
               }}
            >
               <FontAwesomeIcon icon={faRecycle} />
               <span>TRI</span>
            </button>
            {curOrderType === tabs.unsync && (
               <button
                  className={filterDEV ? styles_Searchbar.state_on : styles_Searchbar.state_off}
                  onClick={() => {
                     setFilterDEV((cur) => !cur)
                  }}
               >
                  <FontAwesomeIcon icon={faFilePen} />
                  <span>DEV</span>
               </button>
            )}
         </div>
      )
      setSearchBar(
         <Searchbar onChange={onSearchChange} text={searchText} placeholder={trans(searchMode === search_type.sku ? '?Chercher un SKU' : '?Chercher une commande')} left_tools={left_toolz}>
            <div className={styles_Searchbar.search_tools}>
               <button
                  className={searchMode === search_type.in_orders ? styles_Searchbar.red : ''}
                  onClick={() => {
                     setSearchMode(search_type.in_orders)
                  }}
               >
                  <FontAwesomeIcon icon={faFileLinesSolid} />
               </button>
               <button
                  className={searchMode === search_type.sku ? styles_Searchbar.red : ''}
                  onClick={() => {
                     setSearchMode(search_type.sku)
                  }}
               >
                  <FontAwesomeIcon icon={isRetailOnly || curOrderType === tabs.quotas || curOrderType === tabs.kotdebug ? faBox : faGem} />
               </button>
            </div>
         </Searchbar>
      )
   }, [
      canCreateKOT,
      canCreateKTM,
      canSyncOrder,
      isOrderComplete,
      canWriteKOT,
      curCustomer,
      curOrder,
      curOrderType,
      default_customer,
      filterCDE,
      filterCDI,
      filterCON,
      filterTRI,
      filterDEV,
      filterOME,
      filterRET,
      hasBoth,
      isRetailOnly,
      isRetailOrder,
      isKOTOrder,
      isKTMOrder,
      isOrderSubmittedOrLocked,
      lowtrans,
      onSearchChange,
      onSelect,
      order_status,
      retailRole,
      roleForSelected,
      searchMode,
      searchText,
      selectedOrder,
      showDropdownMenuOnOrderId,
      trans
   ])

   const onSelectGlobal = useCallback((id) => {
      setShowDropdownMenuGlobal(false)
      if (id === global_menu_items.doSync) {
         setIsConfirmSyncVisible(true)
      } else if (id === global_menu_items.doSubmit) {
         setIsConfirmSubmitVisible(true)
      }
   }, [])

   useEffect(() => {
      setDropdownMenuGlobal(
         <DropdownMenu noscrollbars right={-20} top={30} onSelect={onSelectGlobal}>
            <li id={global_menu_items.doSubmit} disabled={!hasCheckedRetail}>
               <FontAwesomeIcon icon={faArrowRight} />
               {trans('?Soumettre')}
            </li>
            <li id={global_menu_items.doSync} disabled={!hasCheckedNonRetail}>
               <FontAwesomeIcon icon={faCloudArrowUp} />
               {trans('?Synchroniser')}
            </li>
         </DropdownMenu>
      )
   }, [onSelectGlobal, trans, hasCheckedRetail, hasCheckedNonRetail])
   // console.log(selectedOrder);

   useEffect(() => {
      setIsDarkLayerVisible(isMailAddressPickerVisible || showKtmDeployer || showQuotaMarkEditor || !!unDeployKtm || !!deployProgress)
   }, [isMailAddressPickerVisible, showKtmDeployer, showQuotaMarkEditor, unDeployKtm, deployProgress, setIsDarkLayerVisible])

   function toogleShowDropdownMenuGlobal(evt) {
      evt.stopPropagation()
      closeAllDropDowns()
      setShowDropdownMenuGlobal(!showDropdownMenuGlobal)
   }

   function toggleCreateMenu(evt) {
      evt.stopPropagation()
      closeAllDropDowns()
      setShowCreateMenu(!showCreateMenu)
   }

   function onSelectCreate(id: string) {
      setShowCreateMenu(false)
      switch (id) {
         case create_menu_items.template:
            doCreateTemplate()
            break
         case create_menu_items.order:
            doCreateOrder()
            break
         case create_menu_items.retail:
            doCreateRetail()
            break
         case create_menu_items.kot:
            doCreateRetailQuota()
            break
         case create_menu_items.editKot:
            doEditCurrentKOT()
            break
         case create_menu_items.importKot:
            kotImportFileRef.current?.click()
            break
         case create_menu_items.ktmRet:
            doCreateKTM('RET')
            break
         case create_menu_items.ktmEre:
            doCreateKTM('ERE')
            break
         case create_menu_items.ktmInterco:
            doCreateKTM('INT')
            break
         case create_menu_items.importJSON:
            jsonImportFileRef.current?.click()
            break
      }
   }

   function onGlobalClick(evt) {
      evt.stopPropagation()
      // prepShowDropDown(null)
      closeAllDropDowns()
   }

   function toggleItemsPerPageShowList() {
      setIsItemsPerPageOpen(!isItemsPerPageOpen)
   }

   function onItemsPerPageSelect(id) {
      // console.log('>>>>>>', id)
      setListPageLength(id)
      setIsItemsPerPageOpen(false)
   }

   function onCancelPickMailAddress() {
      setIsMailAddressPickerVisible(false)
   }

   const onValidatePickMailAddress = useCallback(
      async (arr_emails, message) => {
         console.log(arr_emails)
         setIsMailAddressPickerVisible(false)

         const order = await getOrderById(lastPickedOrderId)
         // Type repris de l'ordre : ECR/ECF utilisent le template _retail (col Disc., total remisé) côté genpdf
         awPushPDF(order?.type ?? 'CDE', order, arr_emails, message)
      },
      [awPushPDF, getOrderById, lastPickedOrderId]
   )

   const pushWaiting = useCallback(() => {
      awPushWaitingOrders()
   }, [awPushWaitingOrders])

   // async function deleteOrder() {
   //    const arr = await db.orders.toArray()
   //    // console.log(arr)
   //    await db.orders.delete(arr[0].id)
   // }

   const doCreateTemplate = useCallback(async () => {
      const id_prospect = `${glob_const.prefix_prospect}${curTarifRegionName}`
      await addFakeLocalCustomer({
         number: id_prospect, //appWriteObject.number,
         id: id_prospect, //appWriteObject.number,
         name: `<PROSPECT ${curTarifRegionName}>`, //appWriteObject.name,
         phones: [], //appWriteObject.phones,
         email: [], //appWriteObject.email,
         // tariffs: JSON.stringify({ "ppu": { "tarif": "PPU012", "currency": "EUR" }, "ces": { "tarif": "CES012", "currency": "EUR" } }),//JSON.parse(appWriteObject.tariffs),
         tariffs: JSON.stringify(curTarifRegion.other), //JSON.parse(appWriteObject.tariffs),
         depot: null, //appWriteObject.depot,
         credit: null, //appWriteObject.credit,
         factures_ouvertes: null, //appWriteObject.factures_ouvertes,
         contacts: [],
         addresses: [],
         last_updated: moment().toISOString() //moment.utc(appWriteObject['$updatedAt']).toISOString(),//format(),
      })
      setCurCustomer(id_prospect)
      const new_order = makeTemplateOrder(id_prospect)
      const curid = await createOrder({ ...new_order, type: 'DEV' })
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [addFakeLocalCustomer, createOrder, curTarifRegion, curTarifRegionName, makeTemplateOrder, navigate, setCurCustomer])

   const doCreateOrder = useCallback(async () => {
      const new_order = makeTemplateOrder(curCustomer)
      const curid = await createOrder(new_order)
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [createOrder, curCustomer, makeTemplateOrder, navigate])

   const doCreateRetail = useCallback(async () => {
      const customer = curCustomer ? getCustomerById(curCustomer) : null
      const orderType = getRetailOrderType(customer)
      if (!orderType) return
      const new_order = makeTemplateOrder(curCustomer)
      new_order.type = orderType === 'ECR' ? type_order.retail_interne : type_order.retail_externe
      const curid = await createOrder(new_order)
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [createOrder, curCustomer, getCustomerById, getRetailOrderType, makeTemplateOrder, navigate, type_order.retail_externe, type_order.retail_interne])

   const createKOTAndNavigate = useCallback(
      async (customerId: string, mark: string) => {
         const new_order = makeTemplateOrder(customerId)
         new_order.type = type_order.retail_quota as any
         new_order.mark = mark
         const curid = await createOrder(new_order)
         navigate(`/order-detail?id=${curid}`, { replace: false })
      },
      [createOrder, makeTemplateOrder, navigate, type_order.retail_quota]
   )

   const doCreateRetailQuota = useCallback(async () => {
      if (!curCustomer) return
      const defaultMark = generateKOTMark()
      const existing = await findKOTByPeriod(curCustomer, defaultMark.substring(defaultMark.length - 6))
      if (!existing) {
         // Aucun KOT pour le mois courant → création directe
         await createKOTAndNavigate(curCustomer, defaultMark)
         return
      }
      // Collision sur le mois courant → ouvrir le picker en mode "création KOT"
      setQuotaInitialMark(defaultMark)
      setQuotaIsKOT(true)
      setQuotaCloneSourceId(null)
      setQuotaCloneTargetCustomerId(null)
      setQuotaCreateKOTCustomerId(curCustomer)
      setShowQuotaMarkEditor(true)
   }, [createKOTAndNavigate, curCustomer, findKOTByPeriod, generateKOTMark])

   const doEditCurrentKOT = useCallback(() => {
      if (currentKOTForCurCustomer?.id) {
         navigate(`/order-detail?id=${currentKOTForCurCustomer.id}`, { replace: false })
      }
   }, [currentKOTForCurCustomer, navigate])

   // Précharge le KOT actif du client courant (pour afficher/masquer l'entrée "Modifier quotas"
   // et changer le label de "Créer quotas" quand un KOT existe déjà).
   useEffect(() => {
      if (!curCustomer) {
         setCurrentKOTForCurCustomer(null)
         return
      }
      let cancelled = false
      findCurrentKOT(curCustomer).then(({ kot }) => {
         if (!cancelled) setCurrentKOTForCurCustomer(kot)
      })
      return () => {
         cancelled = true
      }
   }, [curCustomer, findCurrentKOT, live_unsync_orders])

   const doCreateKTM = useCallback(
      (clientType: KTMClientType) => {
         setQuotaInitialMark(generateKTMMark(clientType))
         setQuotaIsKOT(false)
         setQuotaCloneSourceId(null)
         setQuotaCloneTargetCustomerId(null)
         setShowQuotaMarkEditor(true)
      },
      [generateKTMMark]
   )

   // existingQuotaMarks dépend du contexte courant de l'éditeur (création KOT, création KTM, clone KTM, clone KOT)
   const existingQuotaMarks = useMemo(() => {
      if (quotaIsKOT) {
         // KOT : marks des KOT existants pour le client cible (création ou clone)
         const targetCustomerId = quotaCreateKOTCustomerId ?? quotaCloneTargetCustomerId
         return (live_unsync_orders ?? []).filter((o) => o.type === type_order.retail_quota && o.mark && (!targetCustomerId || o.customer_id === targetCustomerId) && o.id !== quotaCloneSourceId).map((o) => o.mark!)
      }
      // KTM : marks de tous les KTM (création ou clone), en excluant la source du clone éventuel
      return (live_unsync_orders ?? []).filter((o) => o.type === type_order.ktm_quota && o.mark && o.id !== quotaCloneSourceId).map((o) => o.mark!)
   }, [live_unsync_orders, type_order.ktm_quota, type_order.retail_quota, quotaIsKOT, quotaCloneSourceId, quotaCloneTargetCustomerId, quotaCreateKOTCustomerId])

   const onValidateQuota = useCallback(
      async (mark: string) => {
         setShowQuotaMarkEditor(false)
         if (quotaCreateKOTCustomerId) {
            // Mode création KOT (collision sur le mois courant → picker affiché pour choisir un autre mois)
            const cid = quotaCreateKOTCustomerId
            setQuotaCreateKOTCustomerId(null)
            await createKOTAndNavigate(cid, mark)
            return
         }
         if (quotaCloneSourceId) {
            // Mode clonage (KOT ou KTM)
            await cloneOrder(quotaCloneSourceId, quotaCloneTargetCustomerId, mark)
            setQuotaCloneSourceId(null)
            setQuotaCloneTargetCustomerId(null)
            setCurOrderType(quotaIsKOT ? tabs.unsync : tabs.templates)
            return
         }
         // Mode création KTM
         const clientType = extractClientTypeFromKTMMark(mark)
         const ktmCustomerId = `${glob_const.prefix_ktm}${clientType}`
         await addFakeLocalCustomer({
            number: ktmCustomerId,
            id: ktmCustomerId,
            name: `<QUOTAS ${KTM_CLIENT_TYPES[clientType]}>`,
            phones: [],
            email: [],
            tariffs: JSON.stringify({ ces: { tarif: null, currency: null }, ppu: { tarif: null, currency: null } }),
            depot: null,
            credit: null,
            factures_ouvertes: null,
            contacts: [],
            addresses: [],
            last_updated: moment().toISOString()
         })
         setCurCustomer(ktmCustomerId)
         const new_order = makeTemplateOrder(ktmCustomerId)
         new_order.type = type_order.ktm_quota as any
         new_order.mark = mark
         const curid = await createOrder(new_order)
         navigate(`/order-detail?id=${curid}`, { replace: false })
      },
      [
         addFakeLocalCustomer,
         cloneOrder,
         createKOTAndNavigate,
         createOrder,
         extractClientTypeFromKTMMark,
         makeTemplateOrder,
         navigate,
         setCurCustomer,
         type_order.ktm_quota,
         KTM_CLIENT_TYPES,
         quotaCloneSourceId,
         quotaCloneTargetCustomerId,
         quotaCreateKOTCustomerId,
         quotaIsKOT
      ]
   )

   function onCancelQuota() {
      setShowQuotaMarkEditor(false)
      setQuotaCloneSourceId(null)
      setQuotaCloneTargetCustomerId(null)
      setQuotaCreateKOTCustomerId(null)
   }

   const onViewExistingQuota = useCallback(
      (mark: string) => {
         const targetType = quotaIsKOT ? type_order.retail_quota : type_order.ktm_quota
         const targetCustomerId = quotaCreateKOTCustomerId ?? quotaCloneTargetCustomerId
         const found = (live_unsync_orders ?? []).find((o) => {
            if (o.mark !== mark || o.type !== targetType) return false
            if (quotaIsKOT && targetCustomerId) return o.customer_id === targetCustomerId
            return true
         })
         if (!found?.id) return
         setShowQuotaMarkEditor(false)
         setQuotaCloneSourceId(null)
         setQuotaCloneTargetCustomerId(null)
         setQuotaCreateKOTCustomerId(null)
         navigate(`/order-detail?id=${found.id}`, { replace: false })
      },
      [live_unsync_orders, navigate, quotaCloneTargetCustomerId, quotaCreateKOTCustomerId, quotaIsKOT, type_order.ktm_quota, type_order.retail_quota]
   )

   /**
    * Déploie le KTM courant vers la liste de clients cochés.
    * - KTM non vide : crée un KOT (mark = QUOTAS_<period>) pour chaque client sans quota, ou remplace
    *   les lignes du KOT existant.
    * - KTM vide : supprime le KOT existant de chaque client pour cette période.
    */
   const onValidateDeployKTM = useCallback(
      async (selectedCustomerIds: string[], opts: KTMDeployOptions) => {
         if (!ktmToDeploy) {
            setShowKtmDeployer(false)
            return
         }
         const period = extractPeriodFromKTMMark(ktmToDeploy.mark ?? null)
         if (!period) {
            toast.error(trans('?Période invalide sur le KTM'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
            setShowKtmDeployer(false)
            return
         }
         // Fermeture immédiate de la KTMDeployer popup. La ProgressPopup prend le relai (plein écran).
         const ktmToDeployLocal = ktmToDeploy
         setShowKtmDeployer(false)
         setKtmToDeploy(null)
         setDeployProgress({ label: trans('?Déploiement en cours'), done: 0, total: selectedCustomerIds.length })

         const targetMark = `QUOTAS_${period}`
         const ktmLines = ktmToDeployLocal.lines ?? []
         const isEmpty = ktmLines.length === 0

         let nbCreated = 0,
            nbUpdated = 0,
            nbDeleted = 0,
            nbSkipped = 0

         for (let i = 0; i < selectedCustomerIds.length; i++) {
            const cid = selectedCustomerIds[i]
            try {
               const existing = await findKOTByPeriod(cid, period)
               if (isEmpty) {
                  if (existing?.id) {
                     await deleteOrder(existing.id)
                     nbDeleted++
                  } else {
                     nbSkipped++
                  }
               } else {
                  if (existing?.id) {
                     const noOpt = !opts.replaceExistingQty && !opts.addNewLines && !opts.removeAbsentLines
                     if (noOpt) {
                        nbSkipped++
                     } else {
                        const merged = mergeKTMIntoKOTLines(existing.lines ?? [], ktmLines, opts)
                        await updateOrder(existing.id, { lines: merged })
                        nbUpdated++
                     }
                  } else {
                     const new_order = makeTemplateOrder(cid)
                     new_order.type = type_order.retail_quota as any
                     new_order.mark = targetMark
                     new_order.lines = ktmLines.map((l) => ({ sku: l.sku, qty: l.qty }))
                     await createOrder(new_order, { quiet: true })
                     nbCreated++
                  }
               }
            } catch (err) {
               console.error(`Deploy KTM sur ${cid} :`, err)
            }
            setDeployProgress({ label: trans('?Déploiement en cours'), done: i + 1, total: selectedCustomerIds.length })
         }

         setDeployProgress(null)

         const parts: string[] = []
         if (nbCreated) parts.push(`${nbCreated} ${trans('?créé', nbCreated)}`)
         if (nbUpdated) parts.push(`${nbUpdated} ${trans('?mis à jour', nbUpdated)}`)
         if (nbDeleted) parts.push(`${nbDeleted} ${trans('?supprimé', nbDeleted)}`)
         if (nbSkipped) parts.push(`${nbSkipped} ${trans('?ignoré', nbSkipped)}`)
         toast.success(`${trans('?Déploiement terminé')} : ${parts.join(', ') || '—'}`, { position: 'top-right', autoClose: 3500, theme: 'colored' })
      },
      [ktmToDeploy, extractPeriodFromKTMMark, findKOTByPeriod, deleteOrder, updateOrder, makeTemplateOrder, createOrder, type_order.retail_quota, trans]
   )

   /**
    * Exécute la suppression du déploiement après confirmation.
    * Supprime les KOTs des clients affichés (tous ceux qui ont un KOT pour la période du KTM).
    */
   const onConfirmUnDeployOK = useCallback(async () => {
      if (!unDeployKtm) return
      const period = extractPeriodFromKTMMark(unDeployKtm.mark ?? null)
      if (!period) {
         toast.error(trans('?Période invalide sur le KTM'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
         setUnDeployKtm(null)
         setUnDeployAffected([])
         setUnDeployCheckedIds([])
         return
      }
      const checkedSet = new Set(unDeployCheckedIds)
      const targets = unDeployAffected.filter((c) => checkedSet.has(c.id!))
      setUnDeployKtm(null)
      setUnDeployAffected([])
      setUnDeployCheckedIds([])
      setDeployProgress({ label: trans('?Suppression du déploiement en cours'), done: 0, total: targets.length })

      let nbDeleted = 0
      for (let i = 0; i < targets.length; i++) {
         const c = targets[i]
         try {
            const existing = await findKOTByPeriod(c.id!, period)
            if (existing?.id) {
               await deleteOrder(existing.id)
               nbDeleted++
            }
         } catch (err) {
            console.error(`UnDeploy KTM sur ${c.id} :`, err)
         }
         setDeployProgress({ label: trans('?Suppression du déploiement en cours'), done: i + 1, total: targets.length })
      }

      setDeployProgress(null)
      toast.success(`${trans('?Déploiement terminé')} : ${nbDeleted} ${trans('?supprimé', nbDeleted)}`, { position: 'top-right', autoClose: 3500, theme: 'colored' })
   }, [unDeployKtm, unDeployAffected, unDeployCheckedIds, extractPeriodFromKTMMark, findKOTByPeriod, deleteOrder, trans])

   const onKOTImportFileChange = useCallback(
      async (e: React.ChangeEvent<HTMLInputElement>) => {
         const file = e.target.files?.[0]
         if (kotImportFileRef.current) kotImportFileRef.current.value = ''
         if (!file) return
         try {
            const result = await importKOTFile(file)
            if (result.lines.length === 0) {
               toast.error(trans('?Aucune ligne valide dans le fichier'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
               return
            }
            const errors = validateKOTLines(result.lines, { skuExists: (sku) => !!getRetailModelById(sku) })
            if (errors.length > 0) {
               toast.error(trans('?Import : SKU manquant, inconnu ou quantité invalide') + '\n' + errors.map((e) => e.message).join('\n'), { position: 'top-right', autoClose: 5000, theme: 'colored' })
               return
            }
            const new_order = makeTemplateOrder(curCustomer)
            new_order.type = type_order.retail_quota as any
            new_order.mark = result.metadata?.period ? `QUOTAS_${result.metadata.period}` : generateKOTMark()
            new_order.lines = result.lines.map((l) => ({ sku: l.sku, qty: l.qty }))
            const curid = await createOrder(new_order)
            toast.success(trans('?Quota créé et lignes importées'), { position: 'top-right', autoClose: 2500, theme: 'colored' })
            navigate(`/order-detail?id=${curid}`, { replace: false })
         } catch {
            toast.error(trans('?Erreur lors de la lecture du fichier'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
         }
      },
      [createOrder, curCustomer, generateKOTMark, getRetailModelById, makeTemplateOrder, navigate, trans, type_order.retail_quota]
   )

   const onJSONImportFileChange = useCallback(
      async (e: React.ChangeEvent<HTMLInputElement>) => {
         const file = e.target.files?.[0]
         if (jsonImportFileRef.current) jsonImportFileRef.current.value = ''
         if (!file) return
         try {
            const text = await file.text()
            const data = JSON.parse(text) as Order
            if (!data.customer_id || !Array.isArray(data.lines)) {
               toast.error(trans('?Fichier JSON invalide'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
               return
            }
            const new_order = makeTemplateOrder(data.customer_id)
            new_order.type = data.type ?? new_order.type
            new_order.lines = new_order.type === TRI_TYPE ? splitLinesToUnit(data.lines) : data.lines
            new_order.mark = data.mark ?? null
            new_order.comment = data.comment ?? null
            new_order.addresses = data.addresses ?? new_order.addresses
            new_order.delivery = data.delivery ?? new_order.delivery
            const curid = await createOrder(new_order)
            toast.success(transWithParams('?Commande %1 créée depuis sauvegarde', [curid]), { position: 'top-right', autoClose: 2500, theme: 'colored' })
            navigate(`/order-detail?id=${curid}`, { replace: false })
         } catch {
            toast.error(trans('?Erreur lors de la lecture du fichier'), { position: 'top-right', autoClose: 3000, theme: 'colored' })
         }
      },
      [createOrder, makeTemplateOrder, navigate, trans, transWithParams]
   )

   // Gardes des entrées du menu « Créer... » (réutilisées par les <li>, le séparateur et le bouton).
   const canCreateBijouxEntry = !!(curCustomer && canCreateBijouxOrder())
   const canCreateRetailEntry = !!(curCustomer && glob_const.retail_enabled && (retailRole === 'client' || roleForCurCustomer.effectiveRole !== null) && canCreateRetailOrder(getCustomerById(curCustomer)))
   const canCreateKotEntry = !!(curCustomer && glob_const.retail_enabled && canCreateKOT(curCustomer))
   const canCreateTemplateEntry = !!(curTarifRegionName && canSeeJewelry)
   const canCreateKtmEntry = !!(glob_const.retail_enabled && canCreateKTM() && canSeeJewelry)
   // Groupe « création » (au-dessus du séparateur).
   const hasCreateGroup = canCreateBijouxEntry || canCreateRetailEntry || canCreateKotEntry || canCreateTemplateEntry || canCreateKtmEntry
   // « Créer depuis sauvegarde » : uniquement si un client est sélectionné (= contexte de création).
   const showRestoreEntry = !!curCustomer
   // Bouton « Créer... » désactivé si AUCUNE entrée n'est affichée dans le menu.
   const hasAnyCreateEntry = hasCreateGroup || showRestoreEntry

   return (
      <Fragment>
         <Menu page="orders" />
         <div className={styles.orders} onClick={onGlobalClick}>
            {searchBar}
            <div className={styles.content}>
               <div className={styles.header_bg}>
                  <div className={styles.header}>
                     <h1>
                        {trans('?Commande', true)} ({allSyncOrders?.length})
                        {curOrderType === tabs.unsync && countFailedSyncOrders > 0 && (
                           <Button small primary red onClick={pushWaiting}>
                              {trans('?Forcer synchronisation')}
                           </Button>
                        )}
                        <div style={{ position: 'relative', marginLeft: 'auto', zIndex: 1000 }}>
                           <Button small disabled={!hasAnyCreateEntry} onClick={toggleCreateMenu}>
                              {trans('?Créer...')}
                           </Button>
                           {showCreateMenu && (
                              <DropdownMenu noscrollbars right={0} top={'50%'} onSelect={onSelectCreate}>
                                 {/* Commande bijoux (BJX/oMe) : éligibilité centralisée (canCreateBijouxOrder)
                                     — exclut user-client et managers Retail (cf. visibilité catalogue BJX). */}
                                 {canCreateBijouxEntry && (
                                    <li id={create_menu_items.order}>
                                       <FontAwesomeIcon icon={faGemLight} />
                                       {trans('?Commande')}
                                    </li>
                                 )}
                                 {canCreateRetailEntry && (
                                    <li id={create_menu_items.retail}>
                                       <FontAwesomeIcon icon={faBoxLight} />
                                       {trans('?Commande Retail')}
                                       {getRetailOrderType(getCustomerById(curCustomer)) === 'ECF' && <FontAwesomeIcon icon={faCoins} style={{ marginLeft: '0.4rem', fontSize: '0.85em' }} />}
                                    </li>
                                 )}
                                 {canCreateKotEntry && currentKOTForCurCustomer && (
                                    <li id={create_menu_items.editKot}>
                                       <FontAwesomeIcon icon={faScaleBalancedLight} />
                                       {trans('?Modifier les quotas')}
                                    </li>
                                 )}
                                 {canCreateKotEntry && (
                                    <li id={create_menu_items.kot}>
                                       <FontAwesomeIcon icon={faScaleBalancedLight} />
                                       {trans(currentKOTForCurCustomer ? '?Créer de nouveaux quotas' : '?Créer des quotas')}
                                    </li>
                                 )}
                                 {canCreateKotEntry && (
                                    <li id={create_menu_items.importKot}>
                                       <FontAwesomeIcon icon={faFileImport} />
                                       {trans('?Importer quota')}
                                    </li>
                                 )}
                                 {canCreateTemplateEntry && (
                                    <li id={create_menu_items.template}>
                                       <FontAwesomeIcon icon={faSheetPlasticLight} />
                                       {trans('?Modèle')} "{curTarifRegionName}"
                                    </li>
                                 )}
                                 {canCreateKtmEntry && (
                                    <>
                                       <li id={create_menu_items.ktmRet}>
                                          <FontAwesomeIcon icon={faObjectGroupLight} />
                                          {trans('?Modèle Quotas')} ECR
                                       </li>
                                       <li id={create_menu_items.ktmEre}>
                                          <FontAwesomeIcon icon={faObjectGroupLight} />
                                          {trans('?Modèle Quotas')} ECF
                                       </li>
                                       <li id={create_menu_items.ktmInterco}>
                                          <FontAwesomeIcon icon={faObjectGroupLight} />
                                          {trans('?Modèle Quotas')} INT
                                       </li>
                                    </>
                                 )}
                                 {/* Séparateur seulement si une entrée de création est au-dessus ET que sauvegarde est en-dessous. */}
                                 {hasCreateGroup && showRestoreEntry && <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '6px 0' }} />}
                                 {/* « Créer depuis sauvegarde » : uniquement si un client est sélectionné. */}
                                 {showRestoreEntry && (
                                    <li id={create_menu_items.importJSON}>
                                       <FontAwesomeIcon icon={faRotateLeft} />
                                       {trans('?Créer depuis sauvegarde')}
                                    </li>
                                 )}
                              </DropdownMenu>
                           )}
                        </div>
                     </h1>
                     <div className={styles.order_types}>
                        <span className={curOrderType === tabs.sync ? styles.selected : ''} onClick={() => setCurOrderType(tabs.sync)}>
                           <FontAwesomeIcon icon={faBagShopping} />
                           {trans('?Traitée', true)} ({filteredSyncOrders?.length})
                           <div className={styles.bot_border} />
                        </span>
                        <span className={curOrderType === tabs.unsync ? styles.selected : ''} onClick={() => setCurOrderType(tabs.unsync)}>
                           <FontAwesomeIcon icon={faCloudSlash} />
                           {trans('?En cours oMe')} ({filteredUnsyncOrders?.length})
                           <div className={styles.bot_border} />
                        </span>
                        {isManagerOrAdmin && (
                           <span className={curOrderType === tabs.pending ? styles.selected : ''} onClick={() => setCurOrderType(tabs.pending)}>
                              <FontAwesomeIcon icon={faFlagCheckered} />
                              {trans('?À valider')} ({filteredPendingOrders?.length ?? 0})
                              <div className={styles.bot_border} />
                           </span>
                        )}
                        {(isManagerOrAdmin || (filteredSubmittedOrders?.length ?? 0) > 0) && (
                           <span className={curOrderType === tabs.submitted ? styles.selected : ''} onClick={() => setCurOrderType(tabs.submitted)}>
                              <FontAwesomeIcon icon={faCloud} />
                              {trans('?Soumises')} ({filteredSubmittedOrders?.length ?? 0})
                              <div className={styles.bot_border} />
                           </span>
                        )}
                        {canManageKOT && (
                           <span className={curOrderType === tabs.quotas ? styles.selected : ''} onClick={() => setCurOrderType(tabs.quotas)}>
                              <FontAwesomeIcon icon={faScaleBalanced} />
                              {trans('?Quotas')} ({filteredQuotaOrders?.length ?? 0})
                              <div className={styles.bot_border} />
                           </span>
                        )}
                        {/* Onglet Modèles masqué pour les retail-only (pas d'accès catalogue bijoux) */}
                        {canSeeJewelry && (
                           <span className={curOrderType === tabs.templates ? styles.selected : ''} onClick={() => setCurOrderType(tabs.templates)}>
                              <FontAwesomeIcon icon={faSheetPlastic} />
                              {trans('?Template', true)} ({filteredTemplateOrders?.length})
                              <div className={styles.bot_border} />
                           </span>
                        )}
                        {/* Onglet debug : réservé admin/N1 (canManageKOT) — un non-admin/N1 (client, N2)
                            ne doit JAMAIS voir de document KOT, même en mode debug. */}
                        {debug && canManageKOT && (
                           <span className={curOrderType === tabs.kotdebug ? styles.selected : ''} onClick={() => setCurOrderType(tabs.kotdebug)}>
                              <FontAwesomeIcon icon={faScaleBalanced} />
                              {'Quotas (debug)'} ({filteredKotOrders.length})
                              <div className={styles.bot_border} />
                           </span>
                        )}
                     </div>
                  </div>
               </div>
               <div className={styles.detail}>
                  <table>
                     <thead>
                        <tr>
                           {curOrderType === tabs.unsync && (
                              <th>
                                 <div>
                                    <Checkbox
                                       small
                                       light
                                       three_states
                                       checked={unsyncLinesNoneChecked ? CheckboxStates.Unchecked : unsyncLinesAllChecked ? CheckboxStates.Checked : CheckboxStates.Undefined}
                                       onChange={() => onSelAllChange(!unsyncLinesAllChecked ? true : false)}
                                    />
                                 </div>
                              </th>
                           )}
                           {/* <th>
                              <div>
                                 {(curOrderType === tabs.unsync) &&
                                    <Checkbox small light three_states checked={unsyncLinesNoneChecked ? CheckboxStates.Unchecked : unsyncLinesAllChecked ? CheckboxStates.Checked : CheckboxStates.Undefined} onChange={() => onSelAllChange(!unsyncLinesAllChecked ? true : false)} />
                                 }
                                 {(curOrderType === tabs.sync) &&
                                    <Checkbox small light three_states checked={syncLinesNoneChecked ? CheckboxStates.Unchecked : syncLinesAllChecked ? CheckboxStates.Checked : CheckboxStates.Undefined} onChange={() => onSelAllChange(!syncLinesAllChecked ? true : false)} />
                                 }
                              </div>
                           </th> */}
                           <th>{trans('?Type')}</th>
                           <th>{trans('?N° Cde')}</th>
                           {curOrderType === tabs.sync && <th className={styles.aligncenter}>oMe</th>}
                           <th>{trans('?Nom client')}</th>
                           <th>{trans('?Date')}</th>
                           <th className={styles.alignright}>{trans('?Prix total')}</th>
                           {curOrderType === tabs.unsync && (
                              <th>
                                 <FontAwesomeIcon icon={faSignature} />
                              </th>
                           )}
                           {(curOrderType === tabs.unsync || curOrderType === tabs.submitted) && <th className={styles.aligncenter}>{trans('?Sync')}</th>}
                           {curOrderType === tabs.unsync && (
                              <th className={styles.action}>
                                 <Button secondary onClick={toogleShowDropdownMenuGlobal} disabled={curOrderType === tabs.unsync && unsyncLinesNoneChecked}>
                                    {trans('?Action', true)}
                                    {showDropdownMenuGlobal && dropdownMenuGlobal}
                                 </Button>
                              </th>
                           )}
                        </tr>
                     </thead>
                     <tbody>
                        {curOrderType === tabs.unsync && unsyncLines}
                        {curOrderType === tabs.pending && pendingLines}
                        {curOrderType === tabs.submitted && submittedLines}
                        {curOrderType === tabs.quotas && quotaLines}
                        {curOrderType === tabs.sync && syncLines}
                        {curOrderType === tabs.templates && templateLines}
                        {curOrderType === tabs.kotdebug && kotDebugLines}
                     </tbody>
                  </table>
                  {/* _{JSON.stringify(unsyncLines)}_
                  _{JSON.stringify(templateLines)}_ */}
               </div>
               <div className={styles.footer_bg}>
                  <div className={styles.footer}>
                     <span>{trans('?Affichage de')}</span>
                     <DropdownField selectedValue={String(listPageLength)} showAbove height={36} onSelect={onItemsPerPageSelect} isOpen={isItemsPerPageOpen} onToggle={toggleItemsPerPageShowList}>
                        <Fragment key="10">10</Fragment>
                        <Fragment key="20">20</Fragment>
                        <Fragment key="50">50</Fragment>
                        <Fragment key="100">100</Fragment>
                        {/* <Fragment key="999999">{lowtrans("?Toutes")}</Fragment> */}
                     </DropdownField>
                     <span>{listPageLength < 99999 ? trans('?par page') : ''}</span>
                     <div>
                        {curOrderType === tabs.unsync && listPageLength < 99999 && pagesButtonsUnsync}
                        {curOrderType === tabs.pending && listPageLength < 99999 && pagesButtonsPending}
                        {curOrderType === tabs.submitted && listPageLength < 99999 && pagesButtonsSubmitted}
                        {curOrderType === tabs.quotas && listPageLength < 99999 && pagesButtonsQuotas}
                        {curOrderType === tabs.sync && listPageLength < 99999 && pagesButtonsSync}
                        {curOrderType === tabs.templates && listPageLength < 99999 && pagesButtonsTemplates}
                        <span></span>
                        <Button>
                           <FontAwesomeIcon icon={faUpToLine} />
                        </Button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {isConfirmDeleteVisible && (
            <Confirm yesno onOK={onConfirmDeleteOK} onCancel={onConfirmDeleteCancel} title={trans('?Suppression')} text={trans(curOrderType === tabs.templates ? '?confirmer_suppression_modele' : '?confirmer_suppression_bdc')} />
         )}
         {isConfirmSyncVisible && <Confirm yesno onOK={onConfirmSyncOK} onCancel={onConfirmSyncCancel} title={trans('?Synchronisation')} text={trans('?confirmer_synchronisation_bdc')} />}
         {isConfirmSubmitVisible && <Confirm yesno onOK={onConfirmSubmitOK} onCancel={onConfirmSubmitCancel} title={trans('?Soumettre')} text={trans('?confirmer_soumission_retail', nbCheckedRetail)} />}
         {showValidateConfirm && (
            <ReliquatConfirm
               title={trans(validateMode === 'n2' ? '?Soumettre' : '?Validation finale')}
               lines={refusedLinesForPopup}
               checked={checkedRefusedLines}
               onToggle={(i) => setCheckedRefusedLines((prev) => prev.map((v, j) => (j === i ? !v : v)))}
               onOK={onValidateConfirmOK}
               onCancel={onValidateConfirmCancel}
            />
         )}
         {finalValidationPopups}
         {returnToClientPopups}
         {submitPopups}
         {isMailAddressPickerVisible && <MailAddressPicker customer={lastPickedOrderCustId} onCancel={onCancelPickMailAddress} onValidate={onValidatePickMailAddress} top={'20%'} minWidth={'30%'} maxWidth={'50%'} />}
         <input type="file" accept=".csv,.xlsx" ref={kotImportFileRef} style={{ display: 'none' }} onChange={onKOTImportFileChange} />
         <input type="file" accept=".json" ref={jsonImportFileRef} style={{ display: 'none' }} onChange={onJSONImportFileChange} />
         {showQuotaMarkEditor && (
            <QuotaMarkEditor value={quotaInitialMark} isKOT={quotaIsKOT} onCancel={onCancelQuota} onValidate={onValidateQuota} existingMarks={existingQuotaMarks} onViewExisting={onViewExistingQuota} top={'20%'} minWidth={'30%'} maxWidth={'50%'} />
         )}
         {showKtmDeployer && ktmToDeploy && (
            <KTMDeployer
               ktm={ktmToDeploy}
               onCancel={() => {
                  setShowKtmDeployer(false)
                  setKtmToDeploy(null)
               }}
               onValidate={onValidateDeployKTM}
               top={'10%'}
               minWidth={'50%'}
               maxWidth={'80%'}
            />
         )}
         {unDeployKtm && (
            <Confirm
               destructive
               title={trans('?Supprimer le déploiement')}
               onOK={onConfirmUnDeployOK}
               onCancel={() => {
                  setUnDeployKtm(null)
                  setUnDeployAffected([])
                  setUnDeployCheckedIds([])
               }}
               enableOK={unDeployCheckedIds.length > 0}
               okLabel={trans('?Supprimer')}
               minWidth={'40%'}
               maxWidth={'60%'}
            >
               {unDeployAffected.length > 0 ? (
                  <>
                     <div>{transWithParams('?Les clients suivants ont des quotas pour la période %1.', [extractPeriodFromKTMMark(unDeployKtm.mark ?? null) ?? ''])}</div>
                     <div>{trans('?Les quotas des clients sélectionnés seront supprimés :')}</div>
                  </>
               ) : (
                  <div>{trans('?Aucun client concerné pour cette période')}</div>
               )}
               {unDeployAffected.length > 0 &&
                  (() => {
                     const total = unDeployAffected.length
                     const nbSel = unDeployCheckedIds.length
                     const masterState = nbSel === 0 ? CheckboxStates.Unchecked : nbSel === total ? CheckboxStates.Checked : CheckboxStates.Undefined
                     const toggleMaster = () => {
                        if (masterState === CheckboxStates.Checked) setUnDeployCheckedIds([])
                        else setUnDeployCheckedIds(unDeployAffected.map((c) => c.id!))
                     }
                     return (
                        <div style={{ maxHeight: '40vh', overflowY: 'auto', margin: '12px 0', border: '1px solid #eee', borderRadius: '6px' }}>
                           <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
                              <thead>
                                 <tr style={{ background: '#fafafa', position: 'sticky', top: 0, zIndex: 1, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                                    <th style={{ padding: '6px 10px', width: 40, textAlign: 'left', background: '#fafafa' }} onClick={(e) => e.stopPropagation()}>
                                       <Checkbox small three_states checked={masterState} onChange={toggleMaster} />
                                    </th>
                                    <th colSpan={2} style={{ padding: '6px 10px', textAlign: 'left', fontWeight: 600, color: '#666', background: '#fafafa' }}>
                                       {trans('?Sélection de')} {nbSel} / {total} {lowtrans('?Client', total)}
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {unDeployAffected.map((c) => {
                                    const checked = unDeployCheckedIds.includes(c.id!)
                                    const toggle = () => setUnDeployCheckedIds((cur) => (checked ? cur.filter((id) => id !== c.id) : [...cur, c.id!]))
                                    return (
                                       <tr key={c.id} style={{ borderBottom: '1px solid #eee', cursor: 'pointer' }} onClick={toggle}>
                                          <td style={{ padding: '6px 10px', width: 40 }}>
                                             <Checkbox small checked={checked ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={toggle} />
                                          </td>
                                          <td style={{ padding: '6px 10px', fontFamily: 'monospace', color: '#666', width: 80 }}>{c.id}</td>
                                          <td style={{ padding: '6px 10px' }}>{c.name}</td>
                                       </tr>
                                    )
                                 })}
                              </tbody>
                           </table>
                        </div>
                     )
                  })()}
            </Confirm>
         )}
         {deployProgress && <ProgressPopup title={deployProgress.label} done={deployProgress.done} total={deployProgress.total} />}
         <ToastContainer />
      </Fragment>
   )
}

export default Orders
